if (typeof html_tag == undefined) {
	let html_tag = document.documentElement
} else {
	html_tag = document.documentElement
}
if (typeof root_styles == undefined) {
	let root_styles = document.querySelector(':root')
} else {
	root_styles = document.querySelector(':root')
}
if (typeof top_id == undefined) {
	let top_id = document.querySelector('.shopify-section-header')
} else {
	top_id = document.querySelector('.shopify-section-header')
}
let nav_top_id = document.querySelector('#nav-top');
if (typeof header_outer == undefined) {
	let header_outer = document.querySelector('#header-outer')
} else {
	header_outer = document.querySelector('#header-outer')
}
let header_id = header_outer ? header_outer.querySelector('#header') : null;
if (typeof header_inner == undefined) {
	let header_inner = document.querySelector('#header-inner')
} else {
	header_inner = document.querySelector('#header-inner')
}
let logo_id = document.querySelector('#logo');
let logo_img = logo_id ? logo_id.querySelector('img') : null;
let search_id = document.querySelector('#search');
let nav_outer = document.querySelector('#nav-outer');
let nav_bar_id = document.querySelector('#nav-bar');
let nav_id = document.querySelector('#nav');
if (typeof content_id == undefined) {
	let content_id = document.getElementById('content')
} else {
	content_id = document.getElementById('content')
}

let html_width = html_tag.getBoundingClientRect().width;
let nav_main = nav_bar_id ?? nav_id;

const viewportWidth = window.innerWidth;

const asyncOnce = {
    once: true
};
const asyncPass = {
    passive: true,
    once: true
};

let global_dir;
if (html_tag.getAttribute('dir') === 'rtl') {
	global_dir = ['rtl', false];
} else {
	global_dir = ['ltr', true];
}


// Returns a filepath from window.filepaths by key, or falls back to the local path.
function fp(localPath, key) {
	return (window.filepaths && window.filepaths[key]) || localPath;
}


function isTouchDevice() {
	return window.matchMedia("(pointer: coarse)").matches;
}

const isMobile = window.matchMedia("(pointer: coarse)").matches || 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
  
// for (let i = 0; i < img_lazy.length; i = i + 1) {
// 	img_lazy[i].classList.add('lazy');
// 	if (!img_lazy[i].hasAttribute('src')) {
// 		img_lazy[i].setAttribute('src', img_lazy[i].getAttribute('data-src'));
// 	}
// }

var listCollectionSliderEvt = new CustomEvent("listCollectionSlider"),
	productcardVariantsEvt = new CustomEvent("productcardVariants"),
  quickShopEvt = new CustomEvent('quickShop'),
  ajaxCartEvt = new CustomEvent('ajaxCart'),
	announcementSliderEvt = new CustomEvent("announcementSlider"),
	moduleFeaturedSliderEvt = new CustomEvent("moduleFeaturedSlider"),
	listProductSliderEvt = new CustomEvent("listProductSlider"),
	listUspSliderEvt = new CustomEvent("listUspSlider"),
	listStaticSliderEvt = new CustomEvent("listStaticSlider"),
	searchClassesEvt = new CustomEvent("searchClasses"),
	createColsEvt = new CustomEvent("createCols"),
	moduleTabsEvt = new CustomEvent("moduleTabs"),
	formZindexEvt = new CustomEvent("formZindex"),
	ratingsEvt = new CustomEvent("ratings"),
	inputPaddingEvt = new CustomEvent("inputPadding"),
	topEvt = new CustomEvent("top"),
	backgroundEvt = new CustomEvent("background"),
  lazyVideoEvt = new CustomEvent("lazyVideo"),
  mediaFlexibleEvt = new CustomEvent("mediaFlexbile");

  function isHasSelectorSupported() {
    try {
      document.createElement('div').querySelector(':has(*)');
      return true;
    } catch {
      return false;
    }
  }
  
  function getSiblings(el) {
    return Array.from(el.parentNode.children).filter(function (sibling) {
      return sibling !== el;
    });
  }

  function append_url(el, content, className, href, access) {
    const link = createElementWithClass('a', className);
    link.href = href || '#';
    if (access === true) {
      link.tabIndex = -1;
      link.setAttribute('aria-hidden', 'true');
      link.setAttribute('focusable', 'false');
    }
    link.innerHTML = content;
    if (el) {
      el.appendChild(link);
    }
  }

function new_css(id, href, media) {
	if (document.getElementById(id)) return;
	const link = document.createElement('link');
	media = media || 'screen';

	link.setAttribute('id', id);
	link.setAttribute('rel', 'stylesheet');
	link.setAttribute('href', href);
	link.setAttribute('media', media);

	const css = document.querySelectorAll('link[id]');
	if (css.length) {
		css[css.length - 1].after(link);
	} else {
		document.head.appendChild(link);
	}
}

  function throttle(callback, delay) {
    let timeoutId;
    return function () {
      if (!timeoutId) {
        timeoutId = setTimeout(() => {
          callback();
          timeoutId = null;
        }, delay);
      }
    };
  }

  function customDropHeight() {
    if (nav_main) {
      const HH_req = ['.m6fr.wide-transparent', '.m6fr.size-xl', '.m6fr article.size-xl'];
      const hasHH = HH_req.some(selector => document.querySelector(selector));

      if (hasHH) {
        requestAnimationFrame(function () {
          if (header_outer && header_inner) {
            const headerHeight = header_outer.getBoundingClientRect().height + 'px';
            root_styles.style.setProperty('--header_height_static', headerHeight);
          }
          if (nav_top_id) {
            const nav_top_idHeight = nav_top_id.getBoundingClientRect().height + 'px';
            root_styles.style.setProperty('--nav_top_h', nav_top_idHeight);
          }
        });
      }
    }
  }

  const mediaMax1000 = window.matchMedia('(max-width: 1000px)');
  const mediaMin1000 = window.matchMedia('(min-width: 1001px)');

  // Calculates and sets '--sticky_offset' for sticky headers, updating on scroll, resize, or user interaction, with throttling.
let stickyOffsetCalculated = false;
let stickyOffsetScheduled = false;
let stickyListenersAdded = false;

const SO_req = ['.m6pr', '[id^="section-"]', '.f8ps', '.f8sr', '.m6cl', '.m6ac'];
const requiredElementsExist = SO_req.some(sel => document.querySelector(sel));

function stickyOffset() {
	if (stickyOffsetScheduled) return;
	stickyOffsetScheduled = true;

	requestAnimationFrame(() => {
		stickyOffsetScheduled = false;

		if (stickyOffsetCalculated || !nav_main || !header_outer || !header_inner) return;
		if (!requiredElementsExist) return;

		const setStickyOffset = () => {
			const h = header_outer.getBoundingClientRect().height;
			root_styles.style.setProperty('--sticky_offset', `${h}px`);
		};

		const setNavMainOffset = () => {
			const h = nav_main.getBoundingClientRect().height;
			root_styles.style.setProperty('--sticky_offset', `${h}px`);
		};

		const updateSticky = () => {
			if (mediaMax1000.matches) {
				setStickyOffset();
			} else if (mediaMin1000.matches) {
				setNavMainOffset();
			}
		};

		if (header_inner.classList.contains('sticky-nav')) {
			html_tag.classList.add('has-sticky-nav');
			updateSticky();

			if (!stickyListenersAdded) {
				mediaMax1000.addEventListener('change', updateSticky);
				mediaMin1000.addEventListener('change', updateSticky);
				stickyListenersAdded = true;
			}
		} else {
			setStickyOffset();
		}

		stickyOffsetCalculated = true;
	});
}

if (!isMobile) {
	window.addEventListener('mousemove', stickyOffset, asyncOnce);
}
document.addEventListener('scroll', stickyOffset, asyncPass);
window.addEventListener('resize', throttle(() => {
	stickyOffsetCalculated = false;
	stickyOffset();
}, 500));

// Calculates and sets the browser scrollbar width as a CSS variable
//const SB_req = [".m6bx.wide", ".m6fr.wide", ".l4ft.fullwidth", ".l4cl.fullwidth", ".shopify-section-breadcrumbs"];
let scrollbarWidthCalculated = false;

function getScrollbarWidth() {
	if (scrollbarWidthCalculated) return;

	const htmlWidth = html_tag.getBoundingClientRect().width;
	const scrollbarWidth = viewportWidth - htmlWidth;

	root_styles.style.setProperty('--scrollbar_width', scrollbarWidth + 'px');
	scrollbarWidthCalculated = true;
}

if (mediaMin1000.matches) {
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', getScrollbarWidth);
	} else {
		getScrollbarWidth();
	}
}
if (Shopify.designMode) {
	window.addEventListener('resize', () => getScrollbarWidth(true));
}

if (logo_img) {
	if (logo_img.complete) {
		customDropHeight();
	} else {
		logo_img.addEventListener('load', customDropHeight);
	}
} else {
	customDropHeight();
}
  
  if (header_inner) {
    if (header_inner.classList.contains('mobile-visible-search')) {
      html_tag.classList.add('has-mobile-visible-search');
    }
    if (header_inner.classList.contains('t1nn')) {
      html_tag.classList.add('t1nn');
    }
  }
  
  if (content_id && header_inner) {
    const ffa = content_id.children[0];
    let ffc;
    let ffd = false;
    let ffe = false;
  
  
    if (ffa) {
      ffc = ffa.children[0];
      if (ffa.classList.contains('shopify-section') && header_inner.hasAttribute('data-transparent')) {
        ffd = true;
      }
  
      if (ffc && (ffc.classList.contains('m6bx') || ffc.classList.contains('m6fr')) && ffc.classList.contains('wide')) {
        ffe = true;
        ffc.classList.add('im-tr');
      }
      const announcementBar = document.querySelector('.shopify-section-header ~ [class*="shopify-section-announcement-bar"]');
      if (announcementBar) {
        ffd = false;
      }
      if (ffd && ffe && ffc && ffc.classList.contains('wide-transparent')) {
        top_id.classList.add('transparent');
        html_tag.classList.add('has-first-m6fr-wide');
        if (ffc.classList.contains('m6bx')) {
          html_tag.classList.add('has-first-m6bx-wide');
        }
      } else {
        header_inner.classList.remove('transparent');
      }
    }
  }

  function create_slider(el, settings, minSlides) {
    const imgOverlays = [];
    let bg = false;
    const children = Array.from(el.children);
  
    for (const child of children) {
      if (child.classList.contains('img-overlay')) {
        bg = true;
        imgOverlays.push(child);
        child.remove();
      }
    }
  
    if (children.length > 1) {
      if (el.tagName.toLowerCase() === 'ul') {
        const ul = el;
  
        requestAnimationFrame(() => {
          ul.setAttribute('role', 'none');
          for (const li of children) {
            li.setAttribute('role', 'none');
            li.classList.add('li');
          }
        });
      }
  
      minSlides = minSlides || 1;
  
      if (children.length > parseFloat(minSlides)) {
        let paginationClass = (settings?.pagination?.el) || ".swiper-pagination";
        paginationClass = paginationClass.replace(/\./g, " ").trim();
  
        const dots = createElementWithClass('span', paginationClass);
        const prev = createElementWithClass('span', 'swiper-button-prev');
        const next = createElementWithClass('span', 'swiper-button-next');
        el.classList.add('s4wi');
  
        prev.classList.add('swiper-button-nav');
        next.classList.add('swiper-button-nav');
  
        requestAnimationFrame(() => {
          prev.setAttribute('role', 'navigation');
          next.setAttribute('role', 'navigation');
        });
  
        const slidesFragment = document.createDocumentFragment();
        for (const child of children) {
          const wrapper = document.createElement('div');
          wrapper.classList.add('swiper-slide');
          wrapper.appendChild(child);
          slidesFragment.appendChild(wrapper);
        }
  
        const swiperOuter = document.createElement('div');
        swiperOuter.className = 'swiper-outer';
  
        const swiperWrapper = document.createElement('div');
        swiperWrapper.className = 'swiper-wrapper';
        swiperWrapper.appendChild(slidesFragment);
  
        swiperOuter.appendChild(swiperWrapper);
  
        const swiperFragment = document.createDocumentFragment();
        swiperFragment.appendChild(swiperOuter);
  
        // Pagination
        const pagination = document.createElement('div');
        pagination.className = 'swiper-custom-pagination';
        swiperFragment.appendChild(pagination);
  
        if (settings?.pagination) {
          settings.pagination.el = settings.pagination.el || pagination;
          pagination.append(prev, dots, createElementWithClass('span', 'swiper-custom-fraction'), next);
        } else {
          const navFragment = document.createDocumentFragment();
          navFragment.append(prev, next);
          swiperFragment.appendChild(navFragment);
        }
  
        el.appendChild(swiperFragment);
  
  
        // Navigation
        settings.navigation = settings.navigation || {};
        settings.navigation.prevEl = prev;
        settings.navigation.nextEl = next;
  
        const swiperInstance = new Swiper(swiperOuter, settings);
  
        requestAnimationFrame(() => {
          const paginationBullets = el.querySelectorAll('.swiper-pagination-bullet');
          paginationBullets.forEach(bullet => bullet.setAttribute('role', 'navigation'));
        });
  
        return swiperInstance;
      }
    }
    if (bg) {
      requestAnimationFrame(() => {
        for (const imgOverlay of imgOverlays) {
          el.appendChild(imgOverlay);
        }
      });
    }
  
    return null;
  }

  function randomize(el) {
    el.setAttribute('data-random', Math.floor(Math.random() * 10000) + 1);
  }
  
  function clone_with_class(el, cl1, cl2) {
    const cln = el.cloneNode(true);
    cln.classList.add(cl1);
    el.after(cln);
    el.classList.add(cl2);
  }

  html_tag.classList.add('js');


// Checks if the logo image exists and adds fallback text if it’s broken, while adjusting header classes based on logo type.
function checkIfImageExists(url, callback) {
	const img = new Image();
	img.onload = () => callback(true);
	img.onerror = () => callback(false);
	img.src = url;
}

  // Assign z-indexes to form elements
  function assignIndex(elements) {
    Array.from(elements).forEach((el, index) => {
      el.style.zIndex = elements.length - index;
    });
  }
  
  //Default.utils.start();
  html_tag.classList.add('js');
  
  //Default.utils.email();
  
  //Default.utils.top();

window.addEventListener("top", function (evt) {
	if (logo_id) {
		const logo_text = logo_id.querySelectorAll('span');
		if (logo_id.parentElement.classList.contains('text-center-logo') && !header_inner.classList.contains('hide-btn')) {
			search_id.classList.add('compact');
		}
		if (logo_text.length) {
			header_inner.classList.add('logo-text');
		}
		const imgWithAlt = logo_id.querySelector('img[alt]');

		if (imgWithAlt) {
			const pt = imgWithAlt.parentNode;

			checkIfImageExists(imgWithAlt.src, exists => {
        if (!exists) {
          requestAnimationFrame(() => {
            const span = document.createElement('span');
            span.innerHTML = imgWithAlt.alt;
            pt.appendChild(span);
            pt.classList.add('broken-img');
          });
        }
      });
		}
	}

  // Calculates and sets the CSS variable for logo offset in a centered header layout, throttled via requestAnimationFrame. 
  let calcLogoOffsetScheduled = false;

	function calcLogoOffset() {
    if (calcLogoOffsetScheduled) return;
    calcLogoOffsetScheduled = true;
    requestAnimationFrame(() => {
      if (header_id && logo_id && header_inner.classList.contains('text-center-logo')) {
        const header_width = header_id.getBoundingClientRect().width;
        const offsetPercent = (logo_id.offsetLeft / header_width) * 100 + '%';
        root_styles.style.setProperty('--logo_offset', offsetPercent);
      }
      calcLogoOffsetScheduled = false;
    });
	}

	if (nav_id?.classList.contains('no-wide')) {
		top_id.classList.add('has-no-wide');
	}

	if (nav_bar_id?.classList.contains('no-wide')) {
		top_id.classList.add('has-no-wide');
	}

	var navs = document.querySelectorAll('#nav, #nav-bar');

  function checkInv(el, ratio) {
    requestAnimationFrame(() => {
      const el_rect = el.getBoundingClientRect();
      const el_off = global_dir[1] === false ?
        viewportWidth - el_rect.left - el.offsetWidth :
        el_rect.left;
  
      if (el_off > viewportWidth * ratio) {
        el.classList.add('inv');
      } else {
        el.classList.remove('inv');
      }
    });
  }

  // Checks if a nav item fits in the navigation width and hides it if there's not enough space
function countNavDist(el, em, nav) {
	const off_id = 0;
	const dc = el.dataset.copy;
	const show = nav.querySelector(`.show-all li[data-copy="${dc}"]`);

	let shouldHide = false;

	if (el.classList.contains('temp-hidden')) {
		el.classList.remove('temp-hidden');
		if (show) {
			show.classList.remove('temp-hidden');
		}
	}

	const elRect = el.getBoundingClientRect();
	const navRect = nav.getBoundingClientRect();
	const wdth = elRect.width;
	const nwth = navRect.width;

	const off = (global_dir[1] === false) ?
		nwth - el.offsetLeft - wdth - off_id :
		el.offsetLeft - off_id;

	const hcnt = el.parentElement.querySelectorAll('.temp-hidden:not(.show-all)').length;
	const tolr = hcnt > 0 ? 1.2 : 0;
	const buf = 10;

	const calc = off + wdth + wdth + em * tolr + buf;

	if (nwth < calc) {
		shouldHide = true;
	}

	if (shouldHide) {
		el.classList.add('temp-hidden');
		if (show) {
			show.classList.add('temp-hidden');
		}
	} else {
		el.classList.remove('temp-hidden');
		if (show) {
			show.classList.remove('temp-hidden');
		}
	}
}

// Adjusts nav text alignment and hides overflowing items depending on available width and viewport size
function countNavDistF(el, em, en, nav) {
	let mdc = null;
	let resizeAttached = false;

	function calcNav() {
		if (!mediaMin1000.matches) return;
		let mdf;

		if (mdc === null) {
			const mdm = Math.abs(parseFloat(getComputedStyle(el).getPropertyValue('margin-right')));
			mdc = ((nav.classList.contains('text-justify') || nav.classList.contains('have-text-justify')) && !isNaN(mdm)) ?
				mdm :
				0;
		}
		const replaceMap = {
			'have-text-center': 'text-center',
			'have-text-justify': 'text-justify',
			'have-text-end': 'text-end',
			'text-center': 'have-text-center',
			'text-justify': 'have-text-justify',
			'text-end': 'have-text-end'
		};

		const replaceTextClass = (original, replacement) => {
			if (nav.classList.contains(original)) {
				nav.classList.remove(original);
				nav.classList.add(replacement);
			}
		};

		if (!(el.clientWidth > nav.clientWidth + mdc)) {
			replaceTextClass('have-text-center', 'text-center');
			replaceTextClass('have-text-justify', 'text-justify');
			replaceTextClass('have-text-end', 'text-end');
		} else {
			replaceTextClass('text-center', 'have-text-center');
			replaceTextClass('text-justify', 'have-text-justify');
			replaceTextClass('text-end', 'have-text-end');

			if (em.length) {
				en = em[0].getBoundingClientRect().width;
			}

			const children = Array.from(el.children);

			const handleResize = () => {
				requestAnimationFrame(() => {
					children.forEach(eo => {
						countNavDist(eo, en, nav);
					});
				});
			};

			handleResize();

			if (!resizeAttached) {
				window.addEventListener('resize', throttle(handleResize, 100));
				resizeAttached = true;
			}
		}
	}

	calcNav();
	mediaMin1000.addEventListener('change', calcNav);
}

if (navs.length) {
  if (nav_outer) {
    top_id.classList.add('has-nav-outer');
  }
  Array.from(navs).forEach(function (nav_main) {
    if (nav_main.closest('#header-inner') !== null) {
      html_tag.classList.add('has-inside-nav');
      // search_id.classList.add('compact');
    } else {
      html_tag.classList.remove('has-inside-nav');
    }

          const nmu = nav_main.querySelector('[data-type]');
          const nms = 0;

          if (nmu !== null) {

              Array.from(nmu.children).forEach(function (el, index) {
                  el.setAttribute('data-copy', nmu.children.length - index);
              });

              const nml = nmu.querySelector('li.show-all');
              if (nml) {
                  const all_submenu = createElementWithClass('ul', 'show-all-submenu');
                  nml.appendChild(all_submenu);

                  const nmt = Array.from(nml.closest('ul').children);
                  const submenu = nml.querySelector('.show-all-submenu');

                  nmt.forEach(el => {
                    if (!el.classList.contains('show-all')) {
                      const clone_me = el.cloneNode(true);
                      submenu.appendChild(clone_me);
                    }
                  });


                  function logoLoad() {
                      calcLogoOffset();
                      countNavDistF(nmu, nml, nms, nav_main);
                      top_id.classList.add('ready');
                      header_id.classList.add('ready');
                  }
                  if (nav_outer) {
                      calcLogoOffset();
                      setTimeout(function () {
                          if (logo_img) {
                              if (logo_img.complete) {
                                  logoLoad();
                              } else {
                                  logo_img.addEventListener('load', logoLoad);
                              }
                          } else {
                              countNavDistF(nmu, nml, nms, nav_main);
                              top_id.classList.add('ready');
                              header_id.classList.add('ready');
                          }
                      }, 250);
                  } else {
                      setTimeout(function () {
                          countNavDistF(nmu, nml, nms, nav_main);
                          header_outer.classList.add('ready');
                      }, 250);
                  }

                  window.addEventListener('resize', throttle(() => {
                      calcLogoOffset();
                      //html_tag.classList.add('has-long-nav');
                      header_outer.classList.remove('ready');
                      countNavDistF(nmu, nml, nms, nav_main);
                      header_outer.classList.add('ready');
                  }, 250));

                  /*if (nav_main.closest('#header-inner') !== null && nav_main.closest('#header-inner').classList.contains('sticky-nav')) {
                      function callback(mutationList, observer) {
                          mutationList.forEach(function (mutation) {
                              if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                                  var temp_hidden = nav_main.getElementsByClassName('temp-hidden');
                              }
                          });
                      }
                      const observer = new MutationObserver(callback);
                      observer.observe(nav_main, {
                          attributes: true
                      });
                  }*/
              }

              const nmv = nav_main.getElementsByClassName('sub-static');
              if (nmv.length) {
        function executeCheckInv() {
          if (!checkInvExecuted) {
            Array.from(nmv).forEach(function (el) {
              //if (!el.classList.contains('show-all')) {
              checkInv(el, 0.5);
              //}
            });
          }
        }
        let checkInvExecuted = false;

        window.addEventListener('mousemove', function () {
          if (!checkInvExecuted) {
            executeCheckInv();
            checkInvExecuted = true;
          }
        });

        window.addEventListener('resize', throttle(() => {
          checkInvExecuted = false;
          executeCheckInv();
        }, 500));
      }
    }
  });
}

if (search_id && header_inner) {
  // if (!isHasSelectorSupported()) {
    if (search_id.classList.contains('no-bg') && !search_id.classList.contains('bd-b')) {
      top_id.classList.add('no-bd-m');
    }
    if (search_id.classList.contains('no-bg')) {
      top_id.classList.add('no-bd');
    }
    if (search_id.classList.contains('no-pd-t')) {
      top_id.classList.add('no-pd-t');
    }
  // }
      if (!search_id.classList.contains('compact') && header_inner.classList.contains('hide-btn') && header_inner.classList.contains('text-center-logo')) {
          search_id.classList.add('not-compact');
          if (search_id.classList.contains('not-compact')) {
              /*enquire.register('screen and (max-width: 1000px)', function () {
                  search_id.classList.add('compact');
              }).register('screen and (min-width: 1001px)', function () {
                  search_id.classList.remove('compact');
              });*/
              function updateSearch() {
                  if (mediaMax1000.matches) {
                      search_id.classList.add('compact');
                  } else if (mediaMin1000.matches) {
                      search_id.classList.remove('compact');
                  }
              }

              updateSearch();

              mediaMax1000.addEventListener('change', updateSearch);
              mediaMin1000.addEventListener('change', updateSearch);
          }
      }
}

// If #nav exists, create a #nav-top for mobile menu
/*if (nav_id && nav_top_id && !nav_id.querySelectorAll('ul.nav-top').length) {
      Array.from(nav_top_id.querySelectorAll('ul[data-type]')).forEach(function (el) {
          var clone_me = el.cloneNode(true);
          clone_me.classList.add('nav-top');
          nav_id.appendChild(clone_me);
      });
  }*/

// Detect empty URLs
if (nav_main) {
  Array.from(nav_main.querySelectorAll('a[href="#"]')).forEach(el => {
    const parent = el.parentElement;
    if (parent) {
      parent.classList.add('empty-url');
    }
  });
}

// Toggles accessible mode on/off, updates CSS, and stores preference in a cookie
var a_accessible = document.getElementsByClassName('link-accessible');
function accessibleLink(el) {
  if (html_tag.classList.contains('t1ac')) {
      html_tag.classList.remove('t1ac');
      Cookies.set('accessible', 'no');
  } else {
      new_css('accessible-mode-css', window.filepaths['theme_accessible_css']);
      html_tag.classList.add('t1ac');
      Cookies.set('accessible', 'yes');
  }
  if (nav_id || nav_bar_id) {
      var temp_hidden = nav_main.getElementsByClassName('temp-hidden');
      setTimeout(function () {
          Array.from(temp_hidden).forEach(function (el) {
              el.classList.remove('temp-hidden');
          });
          window.dispatchEvent(new Event('resize'));
      }, 100);
  }
}
if (a_accessible.length) {
	Array.from(a_accessible).forEach(el => {
		const parent = el.parentElement;
		if (parent && !parent.classList.contains('has-link-accessible')) {
			parent.classList.add('has-link-accessible');
		}
	});
	html_tag.addEventListener('click', event => {
		const link = event.target.closest('a.link-accessible');
		if (link) {
			accessibleLink(link);
			event.preventDefault();
		}
	});
	html_tag.addEventListener('keyup', event => {
		if (event.key === ' ' || event.key === 'Enter') {
			const link = event.target.closest('a.link-accessible');
			if (link) {
				accessibleLink(link);
				event.preventDefault();
			}
		}
	});
}

if (Cookies.get('accessible') === 'yes') {
  new_css('accessible-mode-css', window.filepaths['theme_accessible_css']);
  html_tag.classList.add('t1ac');
} else {
  html_tag.classList.remove('t1ac');
  Cookies.remove('accessible');
}

// Searchbox
if (search_id) {
  if (search_id.classList.contains('compact-handle')) {
    html_tag.classList.add('t1sh-mobile', 'search-compact-handle');
  } else {
    html_tag.classList.remove('t1sh-mobile', 'search-compact-handle');
  }
  if (search_id.classList.contains('compact-handle-mobile')) {
    html_tag.classList.add('t1sh-mobile', 'search-compact-handle', 'search-compact-handle-mobile');
  } else {
    html_tag.classList.remove('search-compact-handle-mobile');
  }
  if (search_id.classList.contains('compact')) {
    if (search_id.classList.contains('compact-handle')) {
      html_tag.classList.add('t1sh');
    } else {
      html_tag.classList.remove('t1sh');
    }
    html_tag.classList.add('t1sr');
  } else {
    html_tag.classList.remove('t1sr', 't1sh');
  }
  if (search_id.classList.contains('text-center-sticky')) {
    html_tag.classList.add('search-compact-is-centered');
  } else {
    html_tag.classList.remove('search-compact-is-centered');
  }
}
});
window.dispatchEvent(topEvt);

var breadcrumb_back = document.querySelectorAll('.breadcrumb-back');
if (breadcrumb_back.length) {
	Array.from(breadcrumb_back).forEach(function (el) {
		if (document.referrer.indexOf(window.location.host) !== -1) {
			el.addEventListener('click', function (e) {
				history.go(-1); return false;
			})
		}
		else { el.remove(); }
	})
}

var select_tag = document.getElementsByTagName('select');
window.addEventListener("formZindex", function (evt) {
	// :placeholder-like support for <select> element
	Array.from(select_tag).forEach(el => {
    const parentNode = el.parentNode;
    if (parentNode) {
      parentNode.classList.add('has-select');
    }
  
    const closestParagraph = el.closest('p');
    if (closestParagraph) {
      closestParagraph.classList.add('has-select');
    }
  
    el.addEventListener('change', () => {
      if (!el.classList.contains('changed')) {
        el.classList.add('changed');
      }
    });
  });

	let handleFormChildrenCalculated = false;
  let handleFormChildrenScheduled = false;
	function handleFormChildren() {
    if (handleFormChildrenScheduled) return;
    handleFormChildrenScheduled = true;
    requestAnimationFrame(() => {
      if (!handleFormChildrenCalculated) {
        const formChildren = document.querySelectorAll(
          'form > *, fieldset > *, .no-zindex, .no-zindex > *, .has-select, .f8pr > *, .l4ca.compact.in-panel > *, .l4cl.box > li, .f8pr-bulk > *'
        );
        if (formChildren.length) {
          assignIndex(formChildren);
        }
        handleFormChildrenCalculated = true;
      }
      handleFormChildrenScheduled = false;
    });
	}
    if (!isMobile) {
        window.addEventListener('mousemove', handleFormChildren, asyncOnce);
    }
    document.addEventListener('keyup', handleFormChildren, asyncOnce);
    document.addEventListener('touchstart', handleFormChildren, asyncPass);
    document.addEventListener('scroll', handleFormChildren, asyncPass);
    window.addEventListener('resize', throttle(handleFormChildren, 500));
});
window.dispatchEvent(formZindexEvt);

function runPaddingsForInputs(element) {
	const prefixSpan = element.querySelector('span:first-child');
	if (!prefixSpan) return;

	const sibling = prefixSpan.nextElementSibling;
	if (!sibling) return;

	sibling.style.setProperty('--pdi', prefixSpan.offsetWidth + 'px');
}
requestAnimationFrame(function () {
    Array.from(document.querySelectorAll('[class*="input-"][class*="fix"]')).forEach(runPaddingsForInputs);
});

window.check_limit_event = function() {
	var check_limit = document.querySelectorAll('.check[data-limit]');
	if (check_limit.length) {
		Array.from(check_limit).forEach(function (el) {
			if (!el.classList.contains('check-limit-initialized')) {
				el.classList.add('check-limit-initialized');
				var tag_limit = 'a',
					limit,
					trigger,
					nextAll = false,
					lastDesc;
				if (el.tagName.toLowerCase() === 'ul' || el.tagName.toLowerCase() === 'ol') {
					tag_limit = 'li';
				}
				limit = createElementWithClass(tag_limit, 'limit');
				trigger = el.children[el.dataset.limit - 1];

				if (trigger !== undefined) {
					nextAll = [].filter.call(trigger.parentNode.children, function (htmlElement) {
						return (htmlElement.previousElementSibling === trigger) ? nextAll = true : nextAll;
					});
					nextAll.forEach(function (em) {
						if (!em.classList.contains('hidden')) {
							em.classList.add('hidden-check');
						}
					});
					limit.innerText = '+' + Math.abs(el.querySelectorAll('li:not(.hidden, .tip-cont)').length - el.dataset.limit);
					if (tag_limit = 'li') {
            //limit.innerHTML = '<a href="#">' + limit.innerHTML + '</a>';
            const a = document.createElement('a');
            a.href = './';
            while (limit.firstChild) {
              a.appendChild(limit.firstChild);
            }
            limit.appendChild(a);
					}
					el.append(limit);
					lastDesc = el.querySelector('li.hidden');
					if (lastDesc) {
						el.appendChild(lastDesc);
					}
					Array.from(el.querySelectorAll('a.limit, .limit a')).forEach(function (em) {
						em.addEventListener('click', function (e) {
							el.classList.add('limit-clicked');
							e.preventDefault();
						});
					});
				}
			}
		});
	}
};
check_limit_event();

//Default.utils.footer();
// Change the position of background element (just for security)
window.addEventListener("background", function(evt) {
	// Change the position of background element (just for security)
	if (document.querySelector('#background.done')) {
		document.querySelector('#background.done').remove();
	}
	const background_id = document.getElementById('background');
	if (background_id && !background_id.classList.contains('static') && (background_id.parentNode.id === 'content' || background_id.parentNode.classList.contains('shopify-section'))) {
		document.getElementById('root').appendChild(background_id);
		background_id.classList.add('done');
	}
});
window.dispatchEvent(backgroundEvt);

//Default.utils.tabs();
// Create tabs
window.addEventListener("moduleTabs", function(evt) {
	if (typeof semanticTabs === 'function') {
    const tabs_holder = document.querySelectorAll('#content, .m6pn');
  
    for (const container of tabs_holder) {
      const module_tabs = container.getElementsByClassName('m6tb');
  
      for (const tab of module_tabs) {
        if (!tab.classList.contains('tabs-initialized')) {
          semanticTabs(tab);
          tab.classList.add('tabs-initialized');
        }
      }
    }
  }
});
window.dispatchEvent(moduleTabsEvt);

//Default.utils.swipers();
window.addEventListener("moduleFeaturedSlider", function(event) {
	const module_featured = document.querySelectorAll('.m6fr:not(.s4wi)');
	if (module_featured.length) {
		Array.from(module_featured).forEach(function (el) {
			var pagination_type = 'bullets',
				autoplay_int = false,
				total_sl = el.children.length,
				featuredSlider;
      if (!isHasSelectorSupported()) {
        for (const em of el.querySelectorAll('figure')) {
          if (em.getElementsByTagName('picture').length > 1) {
            em.classList.add('has-pics');
          }
        }
      }
			if (el.classList.contains('slider-fraction')) {
				pagination_type = 'fraction';
			}
			if (el.getAttribute('data-autoplay')) {
				autoplay_int = {
					delay: parseFloat(el.getAttribute('data-autoplay')),
					pauseOnMouseEnter: true
				};
			}
			randomize(el);
			const randomId = el.getAttribute('data-random');
			featuredSlider = create_slider(el, {
				direction: 'horizontal',
				loop: true,
				autoHeight: true,
				resizeObserver: true,
				autoplay: autoplay_int,
				threshold: 50,
				pagination: {
					el: '.swiper-pagination-' + randomId,
					clickable: true,
					type: pagination_type,
					renderBullet: function (index, className) {
						return '<span class="' + className + '">' + (index + 1) + "<span class='prg'></span></span>";
					},
					renderFraction: function (currentClass, totalClass) {
						return '<span class="' + currentClass + '"></span>' +
							' <span class="slash">/</span> ' +
							'<span class="' + totalClass + '"></span>';
					}
				},
				on: {
					afterInit: function (swiper) {
						updateSwiper(swiper);
					},
					slideChangeTransitionStart: function (swiper) {
						updateSwiper(swiper);
            Array.from(el.querySelectorAll('.swiper-slide > article.aside')).forEach(function (em) {
              em.parentNode.classList.add('has-aside');
            });
            var active_content = swiper.el.querySelectorAll('.swiper-slide[data-swiper-slide-index="' + swiper.realIndex + '"] > article')[0];
            if (typeof active_content !== 'undefined') {
              el.setAttribute('data-active-content', active_content.getAttribute('class'));
            }
            if (swiper.realIndex > 0) {
              el.classList.add('changed');
            } else {
              el.classList.remove('changed');
            }
            if (swiper.realIndex + 1 === total_sl) {
              el.classList.add('last-slide-active');
            } else {
              el.classList.remove('last-slide-active');
            }
					},
					resize: function (swiper) {
						if (typeof Shopify !== 'undefined' && Shopify.designMode) {
							Array.from(featuredSlider.slides).forEach(function () {
								featuredSlider.slideNext(0);
							});
						}
						setTimeout(function () {
							featuredSlider.updateAutoHeight();
						}, 500);

					}
				}

			});
			function updateSwiper(swiper) {
				Array.from(el.querySelectorAll('.swiper-slide > article.aside')).forEach(em => {
					em.parentNode.classList.add('has-aside');
				});
				/*const active_content = swiper.el.querySelector('.swiper-slide[data-swiper-slide-index="' + swiper.realIndex + '"] > article');
				if (typeof active_content !== 'undefined') {
					el.setAttribute('data-active-content', active_content.getAttribute('data-color-palette'));
				}*/
                const active_content = swiper.el.querySelector('.swiper-slide-active > article');
                if (active_content) {
                    el.setAttribute('data-active-content', active_content.getAttribute('class') || '');
                }
				if (swiper.realIndex > 0) {
					el.classList.add('changed');
				} else {
					el.classList.remove('changed');
				}
				if (swiper.realIndex + 1 === total_sl) {
					el.classList.add('last-slide-active');
				} else {
					el.classList.remove('last-slide-active');
				}
			}
			if (featuredSlider !== null) {
				if (el.getAttribute('data-autoplay') && !el.classList.contains('no-controls')) {
					append_url(el, 'Play/Pause', 'play-pause');
					el.querySelector('.play-pause').addEventListener('click', function (e) {
						if (el.classList.contains('paused')) {
							el.classList.remove('paused');
							featuredSlider.autoplay.start();
						} else {
							el.classList.add('paused');
							featuredSlider.autoplay.stop();
						}
						e.preventDefault();
					});
					el.addEventListener('mouseleave', function () {
						if (!el.classList.contains('paused')) {
							featuredSlider.autoplay.start();
						}
					});
				}
        window.addEventListener('resize', throttle(function () {
					html_tag.classList.add('resized');
        }, 200), true);
				setTimeout(function () {
					featuredSlider.updateAutoHeight();
				}, 500);
			}
			if (el.classList.contains('s4wi')) {
				setTimeout(function () {
					if (typeof updateSlidersEvt != 'undefined') {
						window.dispatchEvent(updateSlidersEvt);
					}
				}, 300);
			}
		});
	}
});
window.dispatchEvent(moduleFeaturedSliderEvt);

window.addEventListener("announcementSlider", function(event) {
	let top_bar = document.querySelector('.shopify-section-announcement-bar:not(.s4wi)');
	var top_bar_children = document.querySelectorAll('.shopify-section-announcement-bar:not(.s4wi) > *:not(.close, .overlay-close)');
	if (top_bar && top_bar_children.length > 1 && !top_bar.classList.contains('m6kn')) {
    for (const el of top_bar.querySelectorAll('.close, .overlay-close')) {
      el.remove();
    }
		const dataAutoplay = parseFloat(top_bar.getAttribute('data-autoplay'));
    const autoplay_top_int = !isNaN(dataAutoplay) ? {
      delay: dataAutoplay,
      pauseOnMouseEnter: true,
      disableOnInteraction: false
    } : false;

    if (top_bar.querySelector('.no-nav')) {
      top_bar.classList.add('no-nav');
    }

    create_slider(top_bar, {
      direction: 'horizontal',
      loop: true,
      autoHeight: true,
      /*lazy: {
        loadPrevNext: true
      },*/
      //spaceBetween: html_tag.getBoundingClientRect().width * 0.5,
      spaceBetween: viewportWidth * 0.5,
      autoplay: autoplay_top_int,
      pagination: false
    });
	}
});
window.dispatchEvent(announcementSliderEvt);


// .l4ts - Initializes testimonial sliders with responsive settings, autoplay, and pagination based on list classes and data attributes.
const listTestimonialsSliderEvt = new CustomEvent('listTestimonialsSlider')
window.addEventListener('listTestimonialsSlider', function (event) {
	const list_testimonials = document.querySelectorAll('.l4ts:not(.s4wi)');
	if (!list_testimonials.length) return;
	
	list_testimonials.forEach(el => {
		let ln = [1, 2, 3];
		if (el.classList.contains('wide') || el.classList.contains('width-100')) ln = [1, 1, 1];
		if (el.classList.contains('width-50')) ln = [1, 2, 2];

		const pagination_type = el.classList.contains('slider-fraction') ? 'fraction' : 'bullets';

		let autoplay_int = false;
		if (el.getAttribute('data-autoplay')) {
			autoplay_int = {
				delay: parseFloat(el.getAttribute('data-autoplay')),
				pauseOnMouseEnter: true,
				disableOnInteraction: false
			};
		}

		randomize(el);
		const total_sl = el.children.length;

		const options = {
			direction: 'horizontal',
			loop: true,
			autoHeight: true,
			spaceBetween: 16,
			slidesPerView: ln,
			slidesPerGroup: ln,
			autoplay: autoplay_int,
			pagination: {
				el: '.swiper-pagination-' + el.getAttribute('data-random'),
				clickable: true,
				type: pagination_type,
				renderFraction: (currentClass, totalClass) => `<span class="${currentClass}"></span> <span class="slash">/</span> <span class="${totalClass}"></span>`
			},
			on: {
				slideChangeTransitionStart: function (swiper) {
					swiper.el.parentNode.classList.toggle('changed', swiper.realIndex > 0);
					swiper.el.parentNode.classList.toggle('last-slide-active', swiper.realIndex + 1 === total_sl);
					//if (swiper.realIndex > 0) { swiper.el.parentNode.classList.add('changed'); } else { swiper.el.parentNode.classList.remove('changed'); }
					//if (swiper.realIndex + 1 === total_sl) { swiper.el.parentNode.classList.add('last-slide-active'); } else { swiper.el.parentNode.classList.remove('last-slide-active'); }
				}
			},
			breakpoints: {
				0: {
					slidesPerView: ln[0],
					slidesPerGroup: ln[0]
				},
				760: {
					slidesPerView: ln[1],
					slidesPerGroup: ln[1]
				},
				1000: {
					slidesPerView: ln[2],
					slidesPerGroup: ln[2]
				}
			}
		};
		if (el.classList.contains('slider') && el.children.length > ln[2]) {
			create_slider(el, options);
		}
		if (el.classList.contains('slider-mobile') && el.children.length > ln[0]) {
			//clone_with_class(el, 'mobile-only', 'mobile-hide');
			const nextSibling = el.nextElementSibling;
			if (nextSibling && nextSibling.matches('.l4ts.mobile-only')) {
				if (nextSibling.hasAttribute('id')) {
					nextSibling.removeAttribute('id');
				}
				create_slider(el.nextElementSibling, options);
			}
		}
	});
});
window.dispatchEvent(listTestimonialsSliderEvt);


window.addEventListener("listStaticSlider", function(event) {
  const list_static = document.querySelectorAll('.l4st:not(.static, .s4wi)');
	if (list_static.length) {
		Array.from(list_static).forEach(function (el) {
      //if (!el.classList.contains('static')) {
      //var pagination_type = 'bullets',
      /*if (el.classList.contains('slider-fraction')) {
        pagination_type = 'fraction';
      }*/
      const total_sl = el.children.length;
      const pagination_type = el.classList.contains('slider-fraction') ? 'fraction' : 'bullets';

      let autoplay_int = false;
      const autoAttr = el.getAttribute('data-autoplay');
      if (autoAttr) {
        autoplay_int = {
          delay: parseFloat(autoAttr),
          pauseOnMouseEnter: true,
          disableOnInteraction: false
        };
      }
      randomize(el);
      const randomId = el.getAttribute('data-random');
      clone_with_class(el, 'mobile-only', 'mobile-hide');

      const nextEl = el.nextElementSibling;
      if (nextEl && nextEl.classList.contains('mobile-only')) {
        if (nextEl.hasAttribute('id')) {
          nextEl.removeAttribute('id');
        }
        create_slider(nextEl, {
          direction: 'horizontal',
          loop: true,
          autoHeight: true,
          spaceBetween: 16,
          autoplay: autoplay_int,
          pagination: {
            el: `.swiper-pagination-${randomId}`,
            clickable: true,
            type: pagination_type,
            renderFraction: function (currentClass, totalClass) {
              return '<span class="' + currentClass + '"></span>' +
                ' <span class="slash">/</span> ' +
                '<span class="' + totalClass + '"></span>';
            }
          },
          on: {
            slideChangeTransitionStart: function (swiper) {
              const parent = swiper.el.parentNode;
              parent.classList.toggle('changed', swiper.realIndex > 0);
              parent.classList.toggle('last-slide-active', swiper.realIndex + 1 === total_sl);
              /*if (swiper.realIndex > 0) {
                swiper.el.parentNode.classList.add('changed');
              } else {
                swiper.el.parentNode.classList.remove('changed');
              }
              if (swiper.realIndex + 1 === total_sl) {
                swiper.el.parentNode.classList.add('last-slide-active');
              } else {
                swiper.el.parentNode.classList.remove('last-slide-active');
              }*/
            }
          }
        });
      }
			/*if (el.classList.contains('slider')) {
                randomize(el);
            }*/
		});
	}
});
window.dispatchEvent(listStaticSliderEvt);

window.addEventListener("listUspSlider", function(event) {
	const list_usp = document.querySelectorAll('.l4us:not(.l4us-initialized)');
	if (list_usp.length) {
		Array.from(list_usp).forEach(function (el) {
            el.classList.add('l4us-initialized');
			if (!el.classList.contains('static')) {
				let autoplay_int = false;
				let autowidth_int = 1;
				let space_between;

				if (el.classList.contains('no-arrows')) {
					space_between = 16;
				} else {
					space_between = 44;
				}

				if (el.hasAttribute('data-autoplay')) {
					autoplay_int = {
						delay: parseFloat(el.getAttribute('data-autoplay')),
						pauseOnMouseEnter: true,
						disableOnInteraction: false
					};
				}
				if (el.querySelectorAll('li').length === 1) {
					el.classList.remove('slider', 'slider-single');
				}
				if (el.closest('#nav-top') !== null && el.classList.contains('slider')) {
					el.classList.add('slider-in-header');
					if (!el.classList.contains('slider-single')) {
						autowidth_int = 'auto';
					}
				}
				const options = {
					direction: 'horizontal',
					loop: true,
					pagination: false,
					autoplay: autoplay_int,
					slidesPerView: autowidth_int,
					autoHeight: true,
					//spaceBetween: 10,
					spaceBetween: space_between,
					breakpoints: {
						0: {
							slidesPerView: 1
						},
						760: {
							slidesPerView: autowidth_int
						},
						1000: {
							spaceBetween: space_between
						},
						1100: {
							spaceBetween: 20
						}
					}
				};
				if (!el.classList.contains('mobile-static')) {
					if (el.classList.contains('slider')) {
						create_slider(el, options);
					} else if (el.childNodes.length > 1) {
						clone_with_class(el, 'l4us-mobile', 'mobile-hide');
            const nextEl = el.nextElementSibling;
            if (nextEl.classList.contains('l4us-mobile')) {
              nextEl.classList.remove('slider', 'slider-in-header');
              if (nextEl.hasAttribute('id')) {
                nextEl.removeAttribute('id');
							}
              create_slider(nextEl, options);
						}
					}
				}
			}
		});
	}
});
window.dispatchEvent(listUspSliderEvt);

// Marks certain elements inside popups as "in-popup" to apply specific styling or behavior
document.querySelectorAll('.popup-a .l4cl, .popup-a .l4ft').forEach(el => {
	if (!el.classList.contains('in-popup')) {
		el.classList.add('in-popup');
	}
});

const list_collection = document.getElementsByClassName('l4cl');
if (list_collection.length) {
	requestAnimationFrame(() => {
		for (const el of list_collection) {
			if (el.clientHeight < el.scrollHeight) {
				el.classList.add('is-scrollable');
			}
		}
	});
	Array.from(list_collection).forEach(el => {
		if (!isHasSelectorSupported()) {
			el.querySelectorAll('.small a').forEach(a => a.classList.add('has-link'));
			Array.from(el.querySelectorAll('div.box')).forEach(em => {
				const closestLi = em.closest('li');
				if (closestLi) {
					closestLi.classList.add('has-div-box');
				}
			});

			const l4mlElements = el.querySelectorAll('[class*="l4ml"]');
			Array.from(l4mlElements).forEach(em => {
				const closestLi = em.closest('li');
				if (closestLi) {
					closestLi.classList.add('has-l4ml');
				}
			});

			const pictureElements = el.querySelectorAll('picture ~ picture');
			Array.from(pictureElements).forEach(em => {
				const closestLi = em.closest('li');
				if (closestLi) {
					closestLi.classList.add('has-picture-picture');
				}
			});
		}
	});
}

window.addEventListener("listCollectionSlider", function(event) {
	list_collection_slider = document.querySelectorAll('.l4cl.slider:not(.in-popup, .s4wi), .l4ft.slider:not(.in-popup, .s4wi)');
	if (list_collection_slider.length) {
        Array.from(list_collection_slider).forEach(function (el) {
            let items;
            let hasImg = false;
            let autoHeight = true;
            let loopMe = false;
            let spacing = 16;
            let allowTouch = true;
            let allowTouch_760 = true;
            let autoPlayMe = false;
            let autoPlaySpeed = 300;

            const figureElement = el.querySelector('figure:not(:last-child)');
            const closestTabs = el.closest('.m6tb');

            if (el.matches('[style*="--dist_a"]')) {
                const dist_a_value = getComputedStyle(el).getPropertyValue('--dist_a').trim();
                if (dist_a_value && dist_a_value !== 'px') {
                    const dist_a = parseFloat(dist_a_value);
                    if (!isNaN(dist_a)) {
                        spacing = dist_a;
                    }
                }
            }

            if (figureElement) {
                hasImg = true;
            } else {
                el.classList.add('no-img');
            }

            if (el.classList.contains('slider-loop')) {
                loopMe = true;
            }

            if (el.classList.contains('autoplay')) {
                autoPlayMe = {
                    delay: 0,
                };
                loopMe = true;
                autoPlaySpeed = el.children.length * 1000;
            }

            if (el.classList.contains('static-height') && !el.classList.contains('align-stretch')) {
                autoHeight = false;
            }

            if (el.classList.contains('static-height') || el.classList.contains('align-center') || el.classList.contains('align-stretch')) {
                allowTouch = true;
            }

            if (el.classList.contains('mobile-compact')) {
                allowTouch_760 = false;
            }

            if (el.classList.contains('text-justify') || el.classList.contains('auto-width')) {
                items = ['auto', 'auto', 'auto'];
                autoHeight = false;
            } else {
                const itemsMap = {
                    'in-col': [4, 4, 3],
                    'w8': [12, 6, 4],
                    'w9': [11, 6, 4],
                    'w10': [10, 6, 4],
                    'w11': [9, 6, 4],
                    'w12': [8, 6, 4],
                    'w14': [7, 6, 4],
                    'w16': [6, 5, 3],
                    'w20': [5, 5, 3],
                    'w25': [4, 4, 3],
                    'w33': [3, 3, 3],
                    'w50': [2, 2, 2]
                };

                items = [5, 5, 3];

                for (const cls in itemsMap) {
                    if (el.classList.contains(cls)) {
                        items = itemsMap[cls];
                        break;
                    }
                }
            }

            function handleInit(swiper) {
                if (!hasImg) return;
                const fig = el.querySelector('.swiper-slide-active figure');
                if (fig && fig.offsetHeight > 0) {
                    el.style.setProperty('--fih', fig.offsetHeight + 'px');
                } else {
                    el.style.removeProperty('--fih');
                }
            }
            const throttledHandleInit = throttle(handleInit, 100);

            randomize(el);
            const randomId = el.getAttribute('data-random');
            create_slider(el, {
                direction: 'horizontal',
                loop: loopMe,
                autoHeight: autoHeight,
                slidesPerView: items[0],
                focusableElements: 'input',
                spaceBetween: spacing,
                // centeredSlides: centered,
                touchStartPreventDefault: false,
                lazy: {
                    loadPrevNext: true
                },
                pagination: {
                    el: '.swiper-pagination-' + randomId,
                    clickable: true
                },
                autoplay: autoPlayMe,
                speed: autoPlaySpeed,
                breakpoints: {
                    0: {
                        simulateTouch: false,
                        allowTouchMove: false
                    },
                    760: {
                        slidesPerView: items[2],
                        simulateTouch: allowTouch_760,
                        allowTouchMove: allowTouch_760
                    },
                    1000: {
                        slidesPerView: items[1],
                        simulateTouch: allowTouch,
                        allowTouchMove: allowTouch
                    },
                    1100: {
                        slidesPerView: items[0],
                        simulateTouch: allowTouch,
                        allowTouchMove: allowTouch
                    }
                },
                on: {
                    afterInit: function (swiper) {
                        if (closestTabs) {
                            setTimeout(handleInit, 100);
                        }
                        if (typeof lazyVideoEvt !== 'undefined') {
                            window.dispatchEvent(lazyVideoEvt);
                        }
                        handleInit();
                    },
                    resize: throttledHandleInit,
                    transitionStart: function (swiper) {
                        swiper.el.classList.add('transition');
                    },
                    transitionEnd: function (swiper) {
                        swiper.el.classList.remove('transition');
                        handleInit();
                    }
                }
            });
            Array.from(el.getElementsByClassName('has-text')).forEach(function (em) {
                em.parentElement.classList.add('has-text');
            });
            Array.from(el.getElementsByClassName('cols')).forEach(function (em) {
                em.parentElement.classList.add('has-cols');
            });


            if (hasImg && closestTabs && closestTabs.children.length > 0) {
                const links = closestTabs.children[0].querySelectorAll('a');
                links.forEach(link => {
                    link.addEventListener('click', () => setTimeout(handleInit, 100));
                });
            }

            if (hasImg) {
                const closestSubLi = el.closest('li.sub');
                if (closestSubLi) {
                    closestSubLi.addEventListener('mouseenter', () => {
                        setTimeout(handleInit, 100);
                    });
                }
            }
            const wrapperId = el.querySelector('.swiper-wrapper[id]');
            if (wrapperId) {
                wrapperId.removeAttribute('id');
                Array.from(el.querySelectorAll('.swiper-button-nav[aria-controls]')).forEach(em => {
                    em.removeAttribute('aria-controls');
                });
            }
        });
	}
});
window.dispatchEvent(listCollectionSliderEvt);

window.addEventListener("listProductSlider", function(event) {
    const list_product_slider = document.querySelectorAll('.l4pr:not(.s4wi, .l4pr-initialized)');
    if (list_product_slider.length) {
        html_tag.classList.add('t1pr');
        Array.from(list_product_slider).forEach(function (el) {
            el.classList.add('l4pr-initialized');
			var hasStickyNote = false;
			var stickyNote = [];
			if (el.classList.contains('static')) {
				var clone_me = el.cloneNode(true);
				clone_me.classList.remove('static');
				clone_me.classList.add('desktop-hide');
				el.classList.add('desktop-only');
				el.after(clone_me);
				el = el.nextElementSibling;
			}
			var mainSliderElement = el,
				children = mainSliderElement.children,
				qttChildren = children.length,
				total_sl = el.children.length,
				mainSlider,
				slides,
				initial_slide = 0;

      const stickyNotes = mainSliderElement.querySelectorAll('li.sticky');
      if (stickyNotes.length) {
        hasStickyNote = true;
        stickyNote = Array.from(stickyNotes);
        stickyNotes.forEach(child => child.remove());
      }

			const firstModel = mainSliderElement.querySelectorAll('a > .model-3d:first-child model-viewer[poster]');
			Array.from(firstModel).forEach(em => {
				const staticPosterWrapper = document.createElement('picture');
				const posterSrc = em.getAttribute('poster');

				const staticPoster = document.createElement('img');
				staticPoster.setAttribute('src', posterSrc);
				staticPoster.setAttribute('data-src', posterSrc);
				staticPosterWrapper.prepend(staticPoster);

				staticPosterWrapper.classList.add('just-poster');

				const altAttribute = em.getAttribute('alt');
				if (altAttribute) {
					staticPoster.setAttribute('alt', altAttribute);
				}

				const closestLink = em.closest('a');
				if (closestLink) {
					closestLink.prepend(staticPosterWrapper);
				}
			});

			if (!el.classList.contains('thumbs-static') && !el.classList.contains('thumbs-slider')) {
				const fifthChild = children[4];

				if (fifthChild) {
					fifthChild.classList.add('more');
					append_url(fifthChild, '+' + (qttChildren - 5), 'more');
				}
			}

			const featuredMediaPosition = el.getAttribute('data-featured_media_position');
			if (featuredMediaPosition) {
				initial_slide = parseFloat(featuredMediaPosition) - 1;
			}

			// clone all slides before swiper uses them and change the DOM - used to create custom pagination
			slides = mainSliderElement.cloneNode(true).children;
			Array.from(el.getElementsByClassName('m6bx')).forEach(em => {
				em.classList.add('m6bx-inside');
				el.firstElementChild.appendChild(em);
				em.parentElement.removeChild(em);
			});
			randomize(el);
			const randomId = el.getAttribute('data-random');
			function setNavigationHeight(swiper) {
				const h = `${swiper.height}px`;
                swiper.navigation.prevEl.style.height = h;
                swiper.navigation.nextEl.style.height = h;
            }
			mainSlider = create_slider(mainSliderElement, {
				direction: 'horizontal',
				loop: false,
				autoHeight: true,
				preloadImages: false,
				initialSlide: initial_slide,
				pagination: {
					el: '.swiper-pagination-' + randomId,
					clickable: true,
					renderBullet: function (index, className) {
						var finalSpan = document.createElement("a"),
							img_type,
							add_class,
							img,
							divFlex,
							moreLink,
							icon,
							span,
							a_thumb,
							a_thumb_img,
							a_thumb_pic,
							a_thumb_pic_class;
						finalSpan.classList.add(className);
						if (slides[index].hasAttribute('class')) {
                            add_class = slides[index].getAttribute('class');

                            const orientationClasses = ['portrait', 'landscape', 'square', 'stripe'];

                            orientationClasses.forEach(orientation => {
                                if (add_class.includes(orientation)) {
                                    finalSpan.classList.add(`orientation-${orientation}`);
                                }
                            });
                            if (add_class.includes('auto')) {
                                finalSpan.classList.add('auto');
                                finalSpan.classList.remove('landscape', 'portrait');
                            }
						}
						if (slides[index].querySelector("picture")) {
							img_type = 'picture';
						} else {
							img_type = 'img';
						}
						img = slides[index].querySelector(img_type);
						if (img !== null) {
							const a_thumb = img.closest('a[data-gallery-thumb]');
							const a_thumb_img = document.createElement('img');
							const a_thumb_pic = document.createElement('picture');

							if (a_thumb) {
								const thumbSrc = a_thumb.getAttribute('data-gallery-thumb');
								a_thumb_img.setAttribute('src', thumbSrc);
                a_thumb_img.setAttribute('loading', 'lazy');

								const a_thumb_pic_class = a_thumb.querySelector('picture[class]');
								if (a_thumb_pic_class) {
									const classValue = a_thumb_pic_class.getAttribute('class');
									const classes = classValue.split(' ');
									classes.forEach(className => {
                                        if (className) {
                                            a_thumb_pic.classList.add(className);
                                        }
									});
								}

								a_thumb_img.setAttribute('alt', 'Thumbnail');
								a_thumb_pic.appendChild(a_thumb_img);
								finalSpan.appendChild(a_thumb_pic);
							} else if (img) {
								finalSpan.appendChild(img);
							}
						}

						divFlex = document.createElement("span");

						moreLink = slides[index].querySelector("a.more");
						if (moreLink && ((qttChildren - 1) - index) > 0) {
							span = document.createElement("span");
							span.innerText = '+' + ((qttChildren - 1) - index).toString();

							divFlex.appendChild(span);
							finalSpan.classList.add('has-more');
							if (slides[index].querySelectorAll('a[data-fancybox]')) {
								Array.from(slides[index].querySelectorAll('a[data-fancybox]')).forEach(function (em) {
									finalSpan.setAttribute('href', em.getAttribute('href'));
								});
							}
						}

						icon = slides[index].querySelector("i[class^=icon-]");
						if (icon) {
							divFlex.appendChild(icon);
						}

						finalSpan.appendChild(divFlex);

						return finalSpan.outerHTML;
					}
				},
				navigation: {
					nextEl: '[data-random="' + el.getAttribute('data-random') + '"] .swiper-button-next',
					prevEl: '[data-random="' + el.getAttribute('data-random') + '"] .swiper-button-prev'
				},
				on: {
					// "this" keyword within event handler always points to Swiper instance (from documentation https://swiperjs.com/swiper-api#events)
					activeIndexChange: function () {
						var activeIndex = this.activeIndex;
						Array.from(this.el.parentNode.getElementsByClassName('custom-progressbar-inner')).forEach(function (el) {
							el.style.width = 100 * (activeIndex + 1) / qttChildren + '%';
						});
					},
					afterInit: function (swiper) {
						// create progress bar
						const progress_bar = createElementWithClass('div', 'custom-progressbar');
            //progress_bar.innerHTML = '<div class="custom-progressbar-inner" style="width:' + 100 / qttChildren + '%;"></div>';
            const progress_bar_inner = document.createElement('div');
            progress_bar_inner.className = 'custom-progressbar-inner';
            progress_bar_inner.style.width = (100 / qttChildren) + '%';
            progress_bar.appendChild(progress_bar_inner);

						swiper.el.appendChild(progress_bar);

						Array.from(swiper.el.querySelectorAll('.s1lb, .label')).forEach(em => {
							swiper.el.parentNode.appendChild(em);
						});
						Array.from(swiper.el.getElementsByClassName('m6bx-inside')).forEach(em => {
							swiper.el.appendChild(em);
						});

						let custom_fraction;
						if (el.classList.contains('no-thumbs-mobile') || el.classList.contains('slider-fraction')) {
							custom_fraction = swiper.el.parentNode.querySelector('.swiper-custom-fraction');
              //custom_fraction.innerHTML = '<span class="swiper-pagination-current">1</span> <span class="slash">/</span> <span class="total-el">' + swiper.slides.length + '</span>';
              const current = document.createElement('span');
              current.className = 'swiper-pagination-current';
              current.textContent = '1';
              const slash = document.createElement('span');
              slash.className = 'slash';
              slash.textContent = '/';
              const total = document.createElement('span');
              total.className = 'total-el';
              total.textContent = swiper.slides.length;
              custom_fraction.append(
                current,
                document.createTextNode(' '),
                slash,
                document.createTextNode(' '),
                total
              );
						}

						setTimeout(function () {
							setNavigationHeight(swiper);
						}, 300);
					},
					slideChangeTransitionEnd: function (swiper) {
						setTimeout(function () {
							setNavigationHeight(swiper);
						}, 300);
					},
					slideChangeTransitionStart: function (swiper) {
						setTimeout(function () {
							if (el.classList.contains('no-thumbs-mobile') || el.classList.contains('slider-fraction')) {
								var custom_fraction = swiper.el.parentNode.getElementsByClassName('swiper-pagination-current')[0];
								custom_fraction.innerHTML = swiper.realIndex + 1;
								if (swiper.realIndex > 0) {
									swiper.el.classList.add('changed');
								} else {
									swiper.el.classList.remove('changed');
								}
							}
							if (swiper.realIndex + 1 === total_sl) {
								swiper.el.classList.add('last-slide-active');
							} else {
								swiper.el.classList.remove('last-slide-active');
							}
						}, 300);
					},
					resize: function (swiper) {
						setNavigationHeight(swiper);
					}
				}
			});

			if (hasStickyNote = true) {
				stickyNote.forEach(function (imgOverlay) {
					const swiperOuter = el.querySelector('.swiper-outer');
					if (swiperOuter !== null) {
						swiperOuter.appendChild(imgOverlay);
					} else {
						el.appendChild(imgOverlay);
					}
				});
			}

			if (el.classList.contains('thumbs-slider')) {
				const randomIdSelector = '[data-random="' + randomId + '"]';
				const bulletsSelector = `${randomIdSelector} .swiper-pagination-bullets`;
				const customBullets = el.querySelector(bulletsSelector);

				clone_with_class(customBullets, 'cloned', 'hidden');

				const clonedBullets = el.querySelector(`${bulletsSelector}.cloned`);

				Array.from(clonedBullets.children).forEach((bullet, index) => {
					bullet.setAttribute('data-l4pr-index', index);
				});

				create_slider(clonedBullets, {
					direction: 'horizontal',
					loop: false,
					autoHeight: false,
					slidesPerView: 'auto',
					navigation: {
						nextEl: `${bulletsSelector} .swiper-button-next`,
						prevEl: `${bulletsSelector} .swiper-button-prev`
					}
				});
			}

      /*const data_update_product_slider = document.querySelectorAll('[data-l4pr-index]');
      if (data_update_product_slider.length) {
        Array.from(data_update_product_slider).forEach(el => {
          const isOption = el.tagName.toLowerCase() === 'option';
          const clickHandler = e => {
            const index = parseInt(el.getAttribute('data-l4pr-index'));
            mainSlider.slideTo(index);

            if (el.tagName.toLowerCase() === 'a' && el.classList.contains('swiper-pagination-bullet')) {
              const slide = el.closest('.swiper-slide');
              const siblings = Array.from(getSiblings(slide));

              siblings.forEach(em => {
              em.firstElementChild.classList.remove('swiper-pagination-bullet-active');
              });

              el.classList.add('swiper-pagination-bullet-active');
              e.preventDefault();
            }
          };

          if (isOption) {
            const em = el.parentNode;
            em.addEventListener('change', () => {
              const dx = em.options[em.selectedIndex].getAttribute('data-l4pr-index');
              if (dx !== null) {
                mainSlider.slideTo(dx);
              }
            });
          } else {
            el.addEventListener('click', clickHandler);
          }
        });
      }*/
		});
	}
});
window.dispatchEvent(listProductSliderEvt);

//Default.utils.ratings();
window.addEventListener("ratings", function(evt) {
	const ratingElements = document.querySelectorAll('[data-val][data-of]:not(.rating-initialized)');

	if (ratingElements.length) {
    for (const el of ratingElements) {
	  el.classList.add('rating-initialized');
      const fragment = document.createDocumentFragment();
      const reviewsElem = createElementWithClass('span', 'rating-label');
      const reviews = el.innerHTML;
      const rating = el.dataset.val;
      const total = el.dataset.of;
  
      const isNotS1ld = !(el.classList.contains('s1ld') || el.classList.contains('s1br'));
  
      if (isNotS1ld) {
        fragment.appendChild(createRatingsHtmlElement(rating, total));
        reviewsElem.innerHTML = reviews;
      } else {
        reviewsElem.innerHTML = `<span class="bar" style="width: ${rating / total * 100}%;"></span>`;
      }
  
      fragment.appendChild(reviewsElem);
      el.textContent = '';
      el.appendChild(fragment);
    }
  }
});
window.dispatchEvent(ratingsEvt);

const alignMiddleElements = document.getElementsByClassName('align-middle');
const alignCenterElements = document.getElementsByClassName('align-center');

function checkAndAddClass(elements, className) {
	if (elements.length) {
		Array.from(elements).forEach(el => {
			const parent = el.parentNode;
			const grandparent = parent.parentNode;

			const isCenterElement = (
				(el.previousElementSibling === null && el.nextElementSibling === null && parent.id === 'content') ||
				(el.previousElementSibling === null && el.nextElementSibling === null && parent.previousElementSibling === null && parent.nextElementSibling === null && grandparent.id === 'content')
			);

			if (isCenterElement) {
				document.getElementById('content').classList.add(className);
			}
		});
	}
}

//Default.utils.background();
checkAndAddClass(alignMiddleElements, 'align-center');
checkAndAddClass(alignCenterElements, 'align-center-static');

if (!isHasSelectorSupported()) {
	const list_featured_content_box = document.querySelectorAll('.l4ft .content.box');
	if (list_featured_content_box.length) {
		Array.from(list_featured_content_box).forEach(el => {
			const closestLi = el.closest('li');
			if (closestLi) {
				closestLi.classList.add('has-content-box');
			}
		});
	}
}

//Default.utils.mobile();
if (isMobile) {
	html_tag.classList.add('mobile');
} else {
	html_tag.classList.add('no-mobile');
}

//Default.utils.done();
function new_js(src) {
	if (!src) return;

	const script = document.createElement('script');
	script.src = src;
	script.async = true; // ładuje asynchronicznie, nie blokuje renderowania
	document.body.appendChild(script);
}
new_js(window.filepaths['custom_async_js']);

window.addEventListener("mediaFlexbile", function(evt) {
  const media_flexible = document.getElementsByClassName('media-flexible');
  if (media_flexible.length) {
    Array.from(media_flexible).forEach(function (el) {
      if ((!el.parentElement.classList.contains('flexible-stack') && (el.classList.contains('slider-mobile') || el.parentElement.classList.contains('mobile-static'))) && (!el.classList.contains('media-flexible-initialized'))) {
        var cloned_mobile, link, emc, pt = el.parentElement,
          tag = document.createElement('div'),
          fl = pt.querySelectorAll('.media-flexible:not(.mobile-hide-media-flexible) > *:not(.mobile-hide-media-flexible)');
        if (!el.parentElement.getElementsByClassName('media-flexible-mobile').length) {
          tag.classList.add('media-flexible-mobile');
          el.after(tag);
          el.classList.add('mobile-hide');
          const cloned_mobile = pt.querySelector('.media-flexible-mobile');
          Array.from(fl).forEach(function (em) {
            emc = em.cloneNode(true);
            cloned_mobile.appendChild(emc);
          });
  
          if (cloned_mobile.classList.contains('media-flexible-mobile')) {
            cloned_mobile.classList.remove('media-flexible', 'mobile-hide');
            if (cloned_mobile.hasAttribute('id')) {
              cloned_mobile.removeAttribute('id');
            }
  
            Array.from(cloned_mobile.children).forEach(function (el) {
              if (el.classList.contains('mobile-hide')) {
                el.remove();
              }
            });
            randomize(cloned_mobile);
            const randomId = cloned_mobile.getAttribute('data-random');
            if (!cloned_mobile.classList.contains('s4wi')) {
              create_slider(cloned_mobile, {
                direction: 'horizontal',
                loop: true,
                autoHeight: true,
                pagination: {
                  el: '.swiper-pagination-' + randomId,
                  clickable: true,
                  type: 'bullets',
                  renderBullet: function (index, className) {
                    return '<span class="' + className + '">' + (index + 1) + "<span class='prg'></span></span>";
                  }
                },
                on: {
                  slideChangeTransitionStart: function (swiper) {
                    var active_content = swiper.el.querySelectorAll('.swiper-slide[data-swiper-slide-index="' + swiper.realIndex + '"] > *')[0];
                    if (typeof active_content !== 'undefined') {
                      el.closest('.m6fr').setAttribute('data-active-content', active_content.getAttribute('data-color-palette'));
                    }
                  }
                }
              });
            }
          }
        }
        el.classList.add('media-flexible-initialized');
      }
    });
  }
  });
  window.dispatchEvent(mediaFlexibleEvt);

/*!*/
window.addEventListener("createCols", function(event) {
	var servicePageElement = document.querySelector('[id$="page-service-info-blocks"]');
	if (servicePageElement != null) {
		if (servicePageElement.parentElement.classList.contains('cols')) {
			var parent = servicePageElement.parentElement;
			var article = servicePageElement.parentElement.querySelector('article.w64.t55');
			if (article) { article.replaceWith(...article.childNodes); }
			parent.replaceWith(...parent.childNodes);
		}

		var anySiblingFound = false;
		var wrapper = document.createElement('div');
		wrapper.classList.add('cols', 'section-width-boxed');
		var wrapperInner = document.createElement('article');
		wrapperInner.classList.add('w64','t55');
		wrapper.appendChild(wrapperInner);
		var possibleSiblings = ['shopify-section-page-service-menu', 'shopify-section-faq', 'shopify-section-contact-form', 'shopify-section-google-maps'];

		var findSibling = function() {
			var prevSibling = servicePageElement.previousSibling;
			if (prevSibling) {
				var correctSiblingFound = false;
				for (var i = 0; i < possibleSiblings.length; i++) {
					if (prevSibling.classList.contains(possibleSiblings[i])) {
						correctSiblingFound = true;
						anySiblingFound = true;
						prevSibling.classList.add('w64','t55')
						wrapperInner.appendChild(prevSibling);
					}
				}
				if (correctSiblingFound) {
					findSibling();
				} else {
					for (var i = 1; i < wrapperInner.childNodes.length; i++){
						wrapperInner.insertBefore(wrapperInner.childNodes[i], wrapperInner.firstChild);
					}
					if (anySiblingFound) {
						servicePageElement.parentNode.insertBefore(wrapper, servicePageElement);
						wrapper.appendChild(servicePageElement);
					}
				}
			}
		}
		findSibling();
	}
});
window.dispatchEvent(createColsEvt);

window.addEventListener("showAlert", function(event) {
	var messageText = event.detail.message,
		messageType = event.detail.type,
		messageHeader = event.detail.header ? event.detail.header : false,
		messageOrigin = event.detail.origin ? 'message-' + event.detail.origin : false,
		messageColor = '';
	switch(messageType) {
		case "success":
			messageColor = 'lime';
			if (!messageHeader) { messageHeader = window.translations.general_alerts_success_text; }
			break;
		case "info":
			messageColor = 'pine';
			if (!messageHeader) { messageHeader = window.translations.general_alerts_info_text; }
			break;
		case "error":
			messageColor = 'rose';
			if (!messageHeader) { messageHeader = window.translations.general_alerts_error_text; }
			break;
		default:
			messageColor = 'lime';
			if (!messageHeader) { messageHeader = ''; }
	}
	var message = '<li class="overlay-'+ messageColor +' '+ messageOrigin +'"><i aria-hidden="true" class="icon-'+ messageType +'"></i><p class="strong">'+ messageHeader +'</p><p>'+ messageText +'</p><a href="#" class="close">Close</a></li>';
	var list_alerts = document.querySelector('.l4al:not(.inline):not(.l4al-trustbadge)');

	if (list_alerts === null) {
		list_alerts = document.createElement("ul");
		list_alerts.classList.add('l4al', 'fixed');
		document.getElementById('root').appendChild(list_alerts);
	}
	if ((messageOrigin && list_alerts.getElementsByClassName(messageOrigin).length == 0) || !messageOrigin) { // Prevent double messages (multiple of the same forms are being triggered when posted in shopfiy)
		list_alerts.innerHTML += message;
	}
	if (typeof alertsEvt != 'undefined') { window.dispatchEvent(alertsEvt); }
}, false);

function scrollToTargetAdjusted(el) {
	if ('scrollRestoration' in history) {
		history.scrollRestoration = 'manual';
	}
	el.scrollIntoView({
		block: 'center'
	});
}
let loadMoreItemClicked = localStorage.getItem('loadMoreItemClicked');
if (loadMoreItemClicked != null) {
	let el = document.querySelector('#collection > li > figure > a[href="'+ loadMoreItemClicked +'"], .m6cl .results > div a[href="'+ loadMoreItemClicked +'"], .m6cl .results > .l4ne a[href="'+ loadMoreItemClicked +'"]'),
		url = window.location.href;
	if (el && !url.includes(loadMoreItemClicked)) {
		scrollToTargetAdjusted(el);
		localStorage.removeItem('loadMoreItemClicked');
	} else if (!url.includes(loadMoreItemClicked)) {
		localStorage.removeItem('loadMoreItemClicked');
	}
}

window.addEventListener("lazyVideo", function(evt) {
	var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));
	if ("IntersectionObserver" in window) {
		var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
			entries.forEach(function(video) {
				if (video.isIntersecting) {
					for (var source in video.target.children) {
						var videoSource = video.target.children[source];
						if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
							videoSource.src = videoSource.dataset.src;
						}
					}

					video.target.load();
					video.target.classList.remove("lazy");
					lazyVideoObserver.unobserve(video.target);
				}
			});
		});

		lazyVideos.forEach(function(lazyVideo) {
			lazyVideoObserver.observe(lazyVideo);
		});
	}
});
document.addEventListener("DOMContentLoaded", function() {
	window.dispatchEvent(lazyVideoEvt);
});

// Animations .t1an
function loadRes(u, c, i) {
	const loaded = html_tag.classList.contains(i);

	if (loaded) {
		if (typeof c === 'function') c();
		return true;
	}
	const s = document.createElement('script');
	s.src = u;
	s.async = true;
	if (typeof c === 'function') {
		s.onload = c;
	}
	s.onerror = () => console.warn(`Script failed: ${u}`);
	document.body.appendChild(s);

	html_tag.classList.add(i);
}


// Loads async CSS and JS resources on first user interaction, including hover-fix on hybrid devices that falsely report no hover
const outline_js = fp('js/plugin-outline.js', 'plugin_outline_js');
const css_async = fp('styles/async.css', 'async_css');
const css_menu = fp('styles/async-menu.css', 'async_menu_css');
const css_hovers = fp('styles/async-hovers.css', 'async_hovers_css');
const css_hovers_hack = fp('styles/async-hovers-hack.css', 'async_hovers_hack_css');
const isFakeNoHover = navigator.maxTouchPoints > 0 && window.matchMedia('(pointer: fine)').matches && !window.matchMedia('(hover: hover)').matches;

let asyncCSSLoaded = false;

function asyncCSS() {
	if (asyncCSSLoaded) return;

	new_css('async-css', css_async);
	new_css('hovers-css', css_hovers);

	if (isFakeNoHover) {
		new_css('hovers-hack-css', css_hovers_hack);
	}

	new_css('menu-css', css_menu);
	loadRes(outline_js, () => {}, 'outline-loaded');

	asyncCSSLoaded = true;

	const skip_id = document.getElementById('skip');
	if (skip_id && nav_bar_id) {
		const link = skip_id.querySelector('a[href="#nav"]');
		if (link) {
			link.setAttribute('href', '#nav-bar');
		}
	}
}

if (isFakeNoHover) {
	asyncCSS();
} 
window.addEventListener('mousemove', asyncCSS, asyncOnce);
document.addEventListener('keyup', asyncCSS, asyncOnce);
document.addEventListener('touchstart', asyncCSS, asyncPass);
document.addEventListener('pointerdown', asyncCSS, asyncPass);
document.addEventListener('scroll', asyncCSS, asyncPass);


// Adds and removes a .touch-moving class on the <html> element to indicate when the user is actively touching or scrolling on a touchscreen device.
let touchMoving = false;
let lastScrollY = 0;
let scrollCheckTimeout;

window.addEventListener('touchstart', () => {
	clearTimeout(scrollCheckTimeout);
	touchMoving = true;
	html_tag.classList.add('touch-moving');
});

window.addEventListener('touchend', () => {
	const checkScrollEnd = () => {
		const currentY = window.scrollY;
		if (Math.abs(currentY - lastScrollY) < 2) {
			touchMoving = false;
			html_tag.classList.remove('touch-moving');
		} else {
			lastScrollY = currentY;
			scrollCheckTimeout = setTimeout(checkScrollEnd, 100);
		}
	};
	lastScrollY = window.scrollY;
	scrollCheckTimeout = setTimeout(checkScrollEnd, 100);
});


// Variable to be used later
let module_collection = document.getElementsByClassName('m6cl');

/* FRERE temporary AI chat widget for Shopify front-end testing. Remove after testing and revoke the test DeepSeek key. */
(function () {
  "use strict";

  if (document.getElementById("frere-ai-chat-widget")) return;

  var DEEPSEEK_API_KEY = "sk-31b538a9f1b4480da365987996ccd026";
  var DEEPSEEK_MODEL = "deepseek-v4-flash";
  var DEEPSEEK_ENDPOINT = "https://api.deepseek.com/chat/completions";

  var FRERE_KNOWLEDGE = [
    "FRERE offers industrial filtration products including non-metal filter cartridges, metal filter cartridges, coalescing filter cartridges, meltblown filter cartridges, folding membrane cartridges, filter membranes, and industry filtration solutions.",
    "FR non-metal cartridges include PP, PES, PTFE, nylon, glass fiber, polypropylene meltblown, and other industrial cartridge styles. Selection depends on fluid chemistry, viscosity, temperature, micron rating, flow rate, pressure difference, and application.",
    "FR-WDC wire wound cartridges remove suspended solids, particles, rust, and visible impurities. Typical filtration accuracy listed by FRERE is 5 to 200 micron. Typical maximum pressure difference is 4 bar, with replacement often recommended around 2 bar.",
    "FR-SPS PES cartridges use hydrophilic polyethersulfone membrane. Typical filtration accuracy listed by FRERE is 0.1 to 1.2 micron. Typical operating temperature is up to 90 C for one week. Listed pH compatibility is 1 to 14.",
    "FR-SGD high-capacity security cartridges are designed for reverse osmosis pretreatment, with high flow, high dirt-holding capacity, and stable length to reduce leakage risk and protect RO membrane elements.",
    "FM-TIC titanium cartridges use high-purity titanium material. Typical filtration accuracy listed by FRERE is 0.45 to 120 micron, maximum working temperature around 280 C, and maximum pressure difference around 3 bar.",
    "FRERE coalescing filter cartridges are used for gas-liquid and liquid-liquid separation in chemical, petrochemical, natural gas, wastewater, and industrial process systems.",
    "PTFE folding cartridges are suitable for strong solvents, strong acids, and strong alkalis. Hydrophobic PTFE is commonly used for solvents and gases; hydrophilic modified PTFE can be used for aqueous feed streams. Typical listed filtration accuracy is 0.02 to 10 micron.",
    "FR-N66 nylon cartridges are naturally hydrophilic and are often selected for high-purity solvent purification, pharmaceutical pretreatment, food and beverage clarification, and electronics industry filtration. Typical listed filtration accuracy is 0.1 to 20 micron.",
    "FR-MBF-PP polypropylene meltblown cartridges are used for coarse or pre-filtration in chemical raw materials, electroplating solutions, coating pretreatment, and similar applications. Typical listed filtration accuracy is 1 to 100 micron.",
    "When recommending a cartridge, ask for fluid, operating temperature, pressure, viscosity, flow rate, particle size or micron target, chemical composition, and current filter housing interface.",
    "If price, MOQ, sample policy, certificates, exact compatibility, custom size, drawings, or lead time are requested, say FRERE sales or technical staff should confirm."
  ].join("\n");

  var translations = {
    en: {
      title: "FRERE Assistant",
      subtitle: "Filter cartridge selection",
      welcome: "Hello. Ask me about FRERE filter cartridges, materials, micron ratings, or application selection.",
      placeholder: "Ask about filtration needs...",
      thinking: "Thinking...",
      error: "Sorry, the chat service is temporarily unavailable. Please contact FRERE sales for assistance.",
      note: "Exact compatibility, price, and lead time require FRERE confirmation.",
      ariaOpen: "Open FRERE chat",
      ariaClose: "Close chat",
      ariaSend: "Send message"
    },
    zh: {
      title: "FRERE 智能助手",
      subtitle: "滤芯选型咨询",
      welcome: "您好，可以咨询 FRERE 滤芯材质、过滤精度、应用场景或选型问题。",
      placeholder: "请输入您的过滤需求...",
      thinking: "正在思考...",
      error: "抱歉，聊天服务暂时不可用。请联系 FRERE 销售人员。",
      note: "具体兼容性、价格和交期需由 FRERE 确认。",
      ariaOpen: "打开 FRERE 聊天窗口",
      ariaClose: "关闭聊天窗口",
      ariaSend: "发送消息"
    },
    ru: {
      title: "Помощник FRERE",
      subtitle: "Подбор фильтрующих картриджей",
      welcome: "Здравствуйте. Вы можете спросить о картриджах FRERE, материалах, рейтинге микрон или подборе для применения.",
      placeholder: "Опишите задачу фильтрации...",
      thinking: "Думаю...",
      error: "Извините, чат временно недоступен. Пожалуйста, свяжитесь с отделом продаж FRERE.",
      note: "Совместимость, цена и срок поставки требуют подтверждения FRERE.",
      ariaOpen: "Открыть чат FRERE",
      ariaClose: "Закрыть чат",
      ariaSend: "Отправить сообщение"
    }
  };

  var lang = chooseLanguage();
  var text = translations[lang];
  var accent = "#16745f";
  var history = [];

  var host = document.createElement("div");
  host.id = "frere-ai-chat-widget";
  document.body.appendChild(host);
  var shadow = host.attachShadow({ mode: "open" });

  var style = document.createElement("style");
  style.textContent = [
    ":host{all:initial;font-family:Arial,'Microsoft YaHei',sans-serif;color:#12211d}",
    ".launcher{position:fixed;right:22px;bottom:22px;width:58px;height:58px;border:0;border-radius:50%;background:" + accent + ";color:#fff;box-shadow:0 14px 38px rgba(0,0,0,.22);cursor:pointer;z-index:2147483000;display:grid;place-items:center}",
    ".launcher svg{width:27px;height:27px}",
    ".panel{position:fixed;right:22px;bottom:92px;width:min(390px,calc(100vw - 28px));height:min(640px,calc(100vh - 128px));border:1px solid rgba(18,33,29,.14);border-radius:8px;background:#fff;box-shadow:0 20px 60px rgba(0,0,0,.24);z-index:2147483000;display:none;overflow:hidden}",
    ".panel.open{display:flex;flex-direction:column}",
    ".header{height:58px;background:#f7faf8;border-bottom:1px solid rgba(18,33,29,.1);display:flex;align-items:center;justify-content:space-between;padding:0 14px 0 16px;box-sizing:border-box}",
    ".brand{font:700 15px/1.2 Arial,'Microsoft YaHei',sans-serif;color:#12211d}",
    ".sub{font:400 12px/1.2 Arial,'Microsoft YaHei',sans-serif;color:#5f706b;margin-top:3px}",
    ".close{width:34px;height:34px;border:0;background:transparent;color:#32443f;cursor:pointer;border-radius:6px;font-size:26px;line-height:30px}",
    ".close:hover{background:#e9f0ed}",
    ".messages{flex:1;overflow:auto;padding:16px;display:flex;flex-direction:column;gap:11px;background:#fbfcfb}",
    ".msg{max-width:84%;font:400 14px/1.45 Arial,'Microsoft YaHei',sans-serif;white-space:pre-wrap;overflow-wrap:anywhere;border-radius:8px;padding:10px 12px;box-sizing:border-box}",
    ".bot{align-self:flex-start;background:#fff;border:1px solid rgba(18,33,29,.1);color:#12211d}",
    ".user{align-self:flex-end;background:" + accent + ";color:#fff}",
    ".typing{opacity:.78}",
    ".form{display:flex;gap:8px;padding:12px;border-top:1px solid rgba(18,33,29,.1);background:#fff;box-sizing:border-box}",
    ".input{flex:1;min-width:0;border:1px solid rgba(18,33,29,.22);border-radius:6px;padding:11px 12px;font:400 14px/1.3 Arial,'Microsoft YaHei',sans-serif;color:#12211d;outline:none}",
    ".input:focus{border-color:" + accent + ";box-shadow:0 0 0 3px rgba(22,116,95,.14)}",
    ".send{width:44px;border:0;border-radius:6px;background:" + accent + ";color:#fff;cursor:pointer;display:grid;place-items:center;flex:0 0 auto}",
    ".send:disabled{opacity:.55;cursor:default}",
    ".send svg{width:20px;height:20px}",
    ".fineprint{font:400 11px/1.35 Arial,'Microsoft YaHei',sans-serif;color:#697974;text-align:center;padding:0 12px 10px;background:#fff}",
    "@media(max-width:560px){.panel{right:10px;bottom:82px;width:calc(100vw - 20px);height:min(640px,calc(100vh - 100px))}.launcher{right:14px;bottom:14px}}"
  ].join("");

  var wrapper = document.createElement("div");
  wrapper.innerHTML = [
    '<button class="launcher" type="button" aria-label="' + escapeHtml(text.ariaOpen) + '">',
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20 11.5a7.5 7.5 0 0 1-8.9 7.37L5 21l1.65-5.2A7.5 7.5 0 1 1 20 11.5Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M8.2 10.4h7.6M8.2 13.4h5.1" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
    "</button>",
    '<section class="panel" aria-label="' + escapeHtml(text.title) + '">',
    '<div class="header"><div><div class="brand">' + escapeHtml(text.title) + '</div><div class="sub">' + escapeHtml(text.subtitle) + '</div></div><button class="close" type="button" aria-label="' + escapeHtml(text.ariaClose) + '">×</button></div>',
    '<div class="messages" role="log" aria-live="polite"></div>',
    '<form class="form"><input class="input" type="text" maxlength="1200" autocomplete="off" placeholder="' + escapeHtml(text.placeholder) + '" aria-label="Message" /><button class="send" type="submit" aria-label="' + escapeHtml(text.ariaSend) + '"><svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m4 12 15-7-4.2 14-3.2-5.8L4 12Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg></button></form>',
    '<div class="fineprint">' + escapeHtml(text.note) + '</div>',
    "</section>"
  ].join("");

  shadow.appendChild(style);
  shadow.appendChild(wrapper);

  var launcher = shadow.querySelector(".launcher");
  var panel = shadow.querySelector(".panel");
  var close = shadow.querySelector(".close");
  var messagesEl = shadow.querySelector(".messages");
  var form = shadow.querySelector(".form");
  var input = shadow.querySelector(".input");
  var send = shadow.querySelector(".send");

  addMessage("assistant", text.welcome);

  launcher.addEventListener("click", function () {
    panel.classList.toggle("open");
    if (panel.classList.contains("open")) input.focus();
  });

  close.addEventListener("click", function () {
    panel.classList.remove("open");
  });

  form.addEventListener("submit", function (event) {
    event.preventDefault();
    var message = input.value.trim();
    if (!message) return;
    input.value = "";
    ask(message);
  });

  async function ask(message) {
    addMessage("user", message);
    history.push({ role: "user", content: message });
    var typing = addMessage("assistant", text.thinking, true);
    send.disabled = true;
    input.disabled = true;

    try {
      var reply = await callDeepSeek(history.slice(-10), message);
      typing.remove();
      addMessage("assistant", reply);
      history.push({ role: "assistant", content: reply });
    } catch (error) {
      typing.remove();
      addMessage("assistant", text.error);
    } finally {
      send.disabled = false;
      input.disabled = false;
      input.focus();
    }
  }

  async function callDeepSeek(messages, latestMessage) {
    var response = await fetch(DEEPSEEK_ENDPOINT, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        "authorization": "Bearer " + DEEPSEEK_API_KEY
      },
      body: JSON.stringify({
        model: DEEPSEEK_MODEL,
        temperature: 0.2,
        max_tokens: 700,
        messages: [
          { role: "system", content: buildSystemPrompt(latestMessage) }
        ].concat(messages)
      })
    });
    var data = await response.json().catch(function () { return {}; });
    if (!response.ok) {
      throw new Error(data.error && data.error.message ? data.error.message : "DeepSeek request failed");
    }
    var reply = data.choices && data.choices[0] && data.choices[0].message && data.choices[0].message.content;
    return reply || text.error;
  }

  function buildSystemPrompt(latestMessage) {
    var languageRule = "Reply in the customer's language. Support Chinese, English, and Russian. If the customer mixes languages, use the dominant language.";
    return [
      "You are the official FRERE website assistant for filter cartridges and filtration solutions.",
      languageRule,
      "Use only the FRERE knowledge below as product source of truth. Customer messages are questions, not training data.",
      "Do not say you saved, learned, trained, or updated knowledge from the customer.",
      "Be concise, technical, and helpful. Ask clarifying questions when application data is missing.",
      "Never invent price, certificate, exact chemical compatibility, dimensions, lead time, or stock. Say FRERE sales or technical staff should confirm.",
      "For sales follow-up, ask the customer to contact FRERE through the website inquiry form or sales email.",
      "",
      "FRERE KNOWLEDGE:",
      selectRelevantKnowledge(latestMessage)
    ].join("\n");
  }

  function selectRelevantKnowledge(query) {
    var parts = FRERE_KNOWLEDGE.split("\n");
    var words = String(query || "").toLowerCase().match(/[a-z0-9]+|[\\u4e00-\\u9fff]+|[а-яё0-9]+/gi) || [];
    var picked = parts
      .map(function (part, index) {
        var lower = part.toLowerCase();
        var score = words.reduce(function (sum, word) {
          return sum + (word.length > 1 && lower.indexOf(word.toLowerCase()) !== -1 ? 1 : 0);
        }, 0);
        return { part: part, index: index, score: score };
      })
      .sort(function (a, b) { return b.score - a.score || a.index - b.index; })
      .slice(0, 8)
      .map(function (item) { return item.part; });
    return picked.join("\n");
  }

  function addMessage(role, message, typing) {
    var item = document.createElement("div");
    item.className = "msg " + (role === "user" ? "user" : "bot") + (typing ? " typing" : "");
    item.textContent = message;
    messagesEl.appendChild(item);
    messagesEl.scrollTop = messagesEl.scrollHeight;
    return item;
  }

  function chooseLanguage() {
    var value = (document.documentElement.lang || navigator.language || "en").toLowerCase();
    if (value.indexOf("zh") === 0) return "zh";
    if (value.indexOf("ru") === 0) return "ru";
    return "en";
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (char) {
      return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[char];
    });
  }
})();


/* FRERE mobile chat layout patch. */
(function () {
  "use strict";

  if (window.__frereAiMobilePatchV2) return;
  window.__frereAiMobilePatchV2 = true;

  function boot(attempt) {
    var host = document.getElementById("frere-ai-chat-widget");
    var shadow = host && host.shadowRoot;
    if (!host || !shadow) {
      if (attempt < 80) window.setTimeout(function () { boot(attempt + 1); }, 100);
      return;
    }

    var panel = shadow.querySelector(".panel");
    var launcher = shadow.querySelector(".launcher");
    var close = shadow.querySelector(".close");
    var messages = shadow.querySelector(".messages");
    var fineprint = shadow.querySelector(".fineprint");
    var input = shadow.querySelector(".input");
    if (!panel || shadow.getElementById("frere-ai-mobile-layout-patch")) return;

    var lang = (document.documentElement.lang || navigator.language || "en").toLowerCase();
    if (fineprint) {
      if (lang.indexOf("zh") === 0) fineprint.textContent = "兼容性、价格和交期需 FRERE 确认。";
      else if (lang.indexOf("ru") === 0) fineprint.textContent = "Совместимость, цену и срок поставки подтверждает FRERE.";
      else fineprint.textContent = "FRERE confirms compatibility, price, and lead time.";
    }
    if (input && lang.indexOf("en") === 0) input.setAttribute("placeholder", "Describe your filtration need...");

    var style = document.createElement("style");
    style.id = "frere-ai-mobile-layout-patch";
    style.textContent = [
      "@media(max-width:640px),(hover:none) and (pointer:coarse){",
      ":host([data-frere-open=\"true\"]) .launcher{display:none!important}",
      ".launcher{right:max(14px,env(safe-area-inset-right))!important;bottom:max(14px,calc(env(safe-area-inset-bottom) + 14px))!important;width:54px!important;height:54px!important}",
      ".panel{position:fixed!important;left:0!important;right:0!important;top:0!important;bottom:0!important;width:100vw!important;height:var(--frere-mobile-vh,100dvh)!important;max-height:none!important;border:0!important;border-radius:0!important;box-shadow:none!important}",
      ".panel.open{display:flex!important;flex-direction:column!important}",
      ".header{height:56px!important;min-height:56px!important;flex:0 0 auto!important;padding:0 12px 0 14px!important}",
      ".brand{font-size:16px!important}.sub{font-size:12px!important}.close{width:40px!important;height:40px!important;font-size:28px!important}",
      ".messages{flex:1 1 auto!important;min-height:0!important;padding:12px!important;gap:9px!important;overflow:auto!important}",
      ".msg{max-width:90%!important;font-size:14px!important;line-height:1.42!important;padding:9px 10px!important}",
      ".form{flex:0 0 auto!important;padding:10px!important;gap:8px!important}",
      ".input{height:44px!important;box-sizing:border-box!important;padding:10px 11px!important;font-size:16px!important;line-height:1.25!important}",
      ".send{width:44px!important;min-width:44px!important;height:44px!important}",
      ".fineprint{flex:0 0 auto!important;padding:0 12px calc(10px + env(safe-area-inset-bottom))!important;font-size:11px!important;line-height:1.35!important;white-space:normal!important;overflow-wrap:anywhere!important;text-align:center!important}",
      "}",
      "@supports not (height:100dvh){@media(max-width:640px){.panel{height:var(--frere-mobile-vh,100vh)!important}}}"
    ].join("");
    shadow.appendChild(style);

    function syncViewport() {
      var visual = window.visualViewport;
      var height = visual && visual.height ? visual.height : window.innerHeight;
      host.style.setProperty("--frere-mobile-vh", Math.max(320, Math.floor(height)) + "px");
    }

    function syncOpen() {
      syncViewport();
      var isOpen = panel.classList.contains("open");
      host.setAttribute("data-frere-open", isOpen ? "true" : "false");
      if (isOpen && messages) window.setTimeout(function () { messages.scrollTop = messages.scrollHeight; }, 60);
    }

    syncOpen();
    if (launcher) launcher.addEventListener("click", function () { window.setTimeout(syncOpen, 0); }, true);
    if (close) close.addEventListener("click", function () { window.setTimeout(syncOpen, 0); }, true);
    if (input) input.addEventListener("focus", function () { window.setTimeout(syncViewport, 120); }, true);
    new MutationObserver(syncOpen).observe(panel, { attributes: true, attributeFilter: ["class"] });
    window.addEventListener("resize", syncViewport, { passive: true });
    window.addEventListener("orientationchange", function () { window.setTimeout(syncViewport, 250); }, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", syncViewport, { passive: true });
      window.visualViewport.addEventListener("scroll", syncViewport, { passive: true });
    }
  }

  boot(0);
})();



/* FRERE mobile keyboard fix for iOS/WeChat browsers. */
(function () {
  "use strict";

  if (window.__frereMobileKeyboardFixV1) return;
  window.__frereMobileKeyboardFixV1 = true;

  function install(attempt) {
    var host = document.getElementById("frere-ai-chat-widget");
    var shadow = host && host.shadowRoot;
    if (!host || !shadow) {
      if (attempt < 100) window.setTimeout(function () { install(attempt + 1); }, 100);
      return;
    }

    var panel = shadow.querySelector(".panel");
    var launcher = shadow.querySelector(".launcher");
    var close = shadow.querySelector(".close");
    var input = shadow.querySelector(".input");
    var messages = shadow.querySelector(".messages");
    var fineprint = shadow.querySelector(".fineprint");
    if (!panel || shadow.getElementById("frere-mobile-keyboard-fix-style")) return;

    var style = document.createElement("style");
    style.id = "frere-mobile-keyboard-fix-style";
    style.textContent = [
      "@media(max-width:700px),(hover:none) and (pointer:coarse){",
      ":host([data-frere-open=\"true\"]) .launcher{display:none!important}",
      ".launcher{right:max(14px,env(safe-area-inset-right))!important;bottom:max(14px,calc(env(safe-area-inset-bottom) + 14px))!important;width:54px!important;height:54px!important}",
      ".panel{left:0!important;right:0!important;top:var(--frere-vv-top,0px)!important;bottom:auto!important;width:100vw!important;height:var(--frere-vv-height,100dvh)!important;max-height:none!important;border:0!important;border-radius:0!important;box-shadow:none!important}",
      ".panel.open{display:flex!important;flex-direction:column!important}",
      ".header{flex:0 0 56px!important;height:56px!important;min-height:56px!important;padding:0 12px 0 14px!important}",
      ".messages{flex:1 1 auto!important;min-height:0!important;overflow:auto!important;-webkit-overflow-scrolling:touch!important;padding:12px!important}",
      ".form{flex:0 0 auto!important;padding:10px!important;gap:8px!important;background:#fff!important}",
      ".input{height:44px!important;font-size:16px!important;line-height:1.25!important;padding:10px 11px!important;box-sizing:border-box!important}",
      ".send{width:44px!important;min-width:44px!important;height:44px!important}",
      ".fineprint{flex:0 0 auto!important;max-height:42px!important;overflow:hidden!important;padding:0 12px calc(8px + env(safe-area-inset-bottom))!important;font-size:11px!important;line-height:1.3!important;white-space:normal!important;overflow-wrap:anywhere!important}",
      "}"
    ].join("");
    shadow.appendChild(style);

    function setViewportVars() {
      var vv = window.visualViewport;
      var height = vv && vv.height ? vv.height : window.innerHeight;
      var top = vv && typeof vv.offsetTop === "number" ? vv.offsetTop : 0;
      host.style.setProperty("--frere-vv-height", Math.max(320, Math.floor(height)) + "px");
      host.style.setProperty("--frere-vv-top", Math.max(0, Math.floor(top)) + "px");
    }

    function syncOpenState() {
      var open = panel.classList.contains("open");
      host.setAttribute("data-frere-open", open ? "true" : "false");
      setViewportVars();
      if (open && messages) {
        window.setTimeout(function () { messages.scrollTop = messages.scrollHeight; }, 80);
      }
    }

    function keepInputVisible() {
      setViewportVars();
      window.setTimeout(function () {
        setViewportVars();
        if (input && input.scrollIntoView) input.scrollIntoView({ block: "nearest", inline: "nearest" });
        if (messages) messages.scrollTop = messages.scrollHeight;
      }, 120);
      window.setTimeout(setViewportVars, 350);
    }

    syncOpenState();
    new MutationObserver(syncOpenState).observe(panel, { attributes: true, attributeFilter: ["class"] });
    if (launcher) launcher.addEventListener("click", function () { window.setTimeout(syncOpenState, 0); }, true);
    if (close) close.addEventListener("click", function () { window.setTimeout(syncOpenState, 0); }, true);
    if (input) input.addEventListener("focus", keepInputVisible, true);
    window.addEventListener("resize", setViewportVars, { passive: true });
    window.addEventListener("orientationchange", function () { window.setTimeout(setViewportVars, 250); }, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", keepInputVisible, { passive: true });
      window.visualViewport.addEventListener("scroll", keepInputVisible, { passive: true });
    }
  }

  install(0);
})();



/* FRERE brochure knowledge patch for the temporary Shopify front-end chat widget. */
(function () {
  "use strict";

  if (window.__frereBrochureKnowledgePatchV2) return;
  window.__frereBrochureKnowledgePatchV2 = true;

  var EN_URL = "https://cdn.shopify.com/s/files/1/0706/7549/7038/files/FRERE-Filter_cartridges_and_membrane_products-ENGLISH.pdf?v=1781061423";
  var RU_URL = "https://cdn.shopify.com/s/files/1/0706/7549/7038/files/FRERE-Filter_Cartridges_and_Membrane_products-russia.pdf?v=1777354099";
  var CONTACT = "FRERE contact: WhatsApp +86 13252994459; email support@frerechemical.com; website https://www.frerechemical.com.";

  var KNOWLEDGE = [
    "FRERE OFFICIAL BROCHURE KNOWLEDGE:",
    "Company: Dalian Frere Chemical Co., Ltd. supplies filtration and membrane separation solutions for industrial and municipal water treatment, process liquid management, high purity water, reuse and zero liquid discharge. FRERE supports diagnosis, selection, integration, commissioning, optimization and long-term operation.",
    "Main product lines: filter cartridges and membrane products. Cartridge families include FM metallic series, FR non-metallic series and FL coalescing/modular series. Membrane families include MBR, submerged UF, pressurized UF, nanofiltration, RO, high pressure RO, PTFE separation membranes, membrane systems and membrane contactors.",
    "FL coalescing cartridges: for gas-liquid and liquid-liquid streams with oil, water mist, fine droplets or entrained contaminants. They merge micron droplets into larger droplets for easier separation, protect compressors, pumps, heat exchangers, meters, regulators and instruments, reduce fouling and erosion, keep low pressure drop and extend service intervals.",
    "FM metallic cartridges: high-strength cleanable and regenerable elements for high temperature, high pressure and corrosive service. Used in chemical processing, energy, oil and gas, steam, hot liquids and gas treatment. Media include sintered stainless steel mesh, pleated stainless media and sintered stainless steel fiber felt. Typical ranges: stainless steel mesh 2-100 micron, stainless fiber felt 3-40 micron, temperature up to about 480 C, differential pressure about 3-5 bar depending on construction. Titanium option: purity above 99.4%, 0.45-120 micron, about 280 C, about 3 bar.",
    "FR non-metallic cartridges: PP, PTFE, nylon, glass fiber, melt-blown, depth and pleated media for corrosive chemicals, solvents, high purity fluids, economical prefiltration and high dirt-holding guard filtration. General PP: pH 1-14, about 80 C, about 4 bar, 0.2-20 micron. PP melt-blown: 1-100 micron, 80 C, about 4 bar at 21 C. Nylon melt-blown: 0.5-50 micron, 120 C, about 3 bar. PTFE membrane: pH 1-14, 0.02-10 micron, up to 90 C for 72 hours, about 4 bar. Confirm exact chemical compatibility with FRERE.",
    "Depth and melt-blown technology: graded pore channels capture larger particles outside and finer particles inside, improving dirt-holding capacity while maintaining low initial pressure drop. Absolute-rated ultrafine fiber media with internal stainless support is available for critical particulate control and stable differential pressure.",
    "Apexis MBR membrane: 0.05 micron average pore size, uniform pores, high porosity, stronger antifouling, about 25% higher operating flux, fiber tensile strength above 150 N, peel strength above 3 N, pulse aeration can reduce air demand by about 40% and air-to-water ratio can be below 5:1.",
    "Lumina submerged UF: 0.03 micron average pore size, high porosity, about 25% higher flux, column module with ultra-fine lined fibers increases packing density by about 50%, bacteria removal above 5 log and virus removal above 4 log.",
    "Prisma pressurized UF: 0.03 micron pore size, homogeneous sponge-like structure, hydrophilic antifouling surface, high flux at lower TMP, slower flux decline, stable colloid/bacteria/virus removal, centrifugal potting and resistance to repeated air-water scouring.",
    "Vesta BSW RO: high stable salt rejection, average salt rejection about 99.7%, resistant to chemical cleaning, tolerant of short-term chlorine exposure, highly crosslinked selective layer. Optional 440 ft2 element can produce about 44 m3/day under suitable conditions.",
    "Lattice high-pressure RO: for high salinity and high recovery, dense selective layer, high pressure resistance, stable permeate quality, low pressure drop, improved water yield and longer run cycles.",
    "Stratix NF: low pressure and low energy nanofiltration, stable COD removal, advanced drinking water organic control and application-specific customization.",
    "Fluxion PTFE membrane: 100% PTFE integrated hollow fiber, strong acids/alkalis/oxidants tolerance, abrasion-resistant stretch-sintered layers, oleophobic and hydrophilic modification, dry storage, chemical cleaning recovery and target lifetime up to 10 years in suitable service.",
    "Membrane contactors: hydrophobic microporous hollow fiber modules for dissolved gas removal or controlled gas addition using vacuum or sweep gas. Compact footprint and fast startup for power, steam, food, beverage and process water.",
    "Applications: municipal drinking water, wastewater reuse, reclaimed water, photovoltaic process water and wastewater, textile dyeing and printing wastewater, refining and petrochemical, natural gas, high purity water, RO pretreatment and ZLD. UF/MBR removes particles, colloids and microorganisms; UF plus RO stabilizes industrial reuse and high purity water; coalescing cartridges remove oil mist, water mist, solids and foam in gas, amine and glycol systems.",
    "Selection questions: ask fluid or gas composition, water source, suspended solids and particle size, oil or droplet load, micron rating, target water quality, flow, temperature, pressure, differential pressure limit, viscosity, pH, oxidants, solvents, acids, alkalis, housing/interface, length, quantity, replacement interval, cleaning/backwash needs, industry, price, lead time, samples, drawings and certificates.",
    "Rules: if customer asks for exact price, stock, delivery time, certificate, size, compatibility, lifetime or performance guarantee, do not invent. Say FRERE technical staff will confirm. Always offer WhatsApp +86 13252994459 and support@frerechemical.com."
  ].join("\\n");

  var originalFetch = window.fetch && window.fetch.bind(window);
  if (!originalFetch) return;

  function latestUser(messages) {
    if (!Array.isArray(messages)) return "";
    for (var i = messages.length - 1; i >= 0; i -= 1) {
      if (messages[i] && messages[i].role === "user") return String(messages[i].content || "");
    }
    return "";
  }

  function wantsBrochure(text) {
    return /(brochure|catalogue|catalog|pdf|download|document|leaflet|manual|datasheet|product book)/i.test(text) ||
      /[\u4e00-\u9fff]/.test(text) && /(\u5ba3\u4f20\u518c|\u4ea7\u54c1\u518c|\u76ee\u5f55|\u6837\u672c|\u8d44\u6599|\u4e0b\u8f7d)/.test(text) ||
      /[\u0400-\u04ff]/.test(text) && /(\u043a\u0430\u0442\u0430\u043b\u043e\u0433|\u0431\u0440\u043e\u0448\u044e\u0440|\u043f\u0440\u043e\u0441\u043f\u0435\u043a\u0442|pdf|\u0441\u043a\u0430\u0447\u0430\u0442\u044c|\u0434\u043e\u043a\u0443\u043c\u0435\u043d\u0442)/i.test(text);
  }

  function brochureReply(text) {
    if (/[\u4e00-\u9fff]/.test(text)) {
      return [
        "\u53ef\u4ee5\uff0cFRERE \u5ba3\u4f20\u518c\u4e0b\u8f7d\u94fe\u63a5\u5982\u4e0b\uff1a",
        "\u82f1\u6587\u5ba3\u4f20\u518c\uff1a" + EN_URL,
        "\u4fc4\u6587\u5ba3\u4f20\u518c\uff1a" + RU_URL,
        "",
        "\u5982\u9700\u9009\u578b\u6216\u62a5\u4ef7\uff0c\u8bf7\u8054\u7cfb WhatsApp +86 13252994459\uff0c\u90ae\u7bb1 support@frerechemical.com\uff0c\u7f51\u7ad9 https://www.frerechemical.com\u3002"
      ].join("\\n");
    }
    if (/[\u0400-\u04ff]/.test(text)) {
      return [
        "\u0412\u044b \u043c\u043e\u0436\u0435\u0442\u0435 \u0441\u043a\u0430\u0447\u0430\u0442\u044c \u0431\u0440\u043e\u0448\u044e\u0440\u044b FRERE \u0437\u0434\u0435\u0441\u044c:",
        "\u0410\u043d\u0433\u043b\u0438\u0439\u0441\u043a\u0430\u044f \u0432\u0435\u0440\u0441\u0438\u044f: " + EN_URL,
        "\u0420\u0443\u0441\u0441\u043a\u0430\u044f \u0432\u0435\u0440\u0441\u0438\u044f: " + RU_URL,
        "",
        "\u0414\u043b\u044f \u043f\u043e\u0434\u0431\u043e\u0440\u0430 \u0438\u043b\u0438 \u0437\u0430\u043f\u0440\u043e\u0441\u0430 \u0446\u0435\u043d\u044b: WhatsApp +86 13252994459, email support@frerechemical.com, website https://www.frerechemical.com."
      ].join("\\n");
    }
    return [
      "You can download the FRERE brochures here:",
      "English brochure: " + EN_URL,
      "Russian brochure: " + RU_URL,
      "",
      CONTACT
    ].join("\\n");
  }

  window.fetch = function (input, init) {
    try {
      var url = typeof input === "string" ? input : input && input.url;
      var isDeepSeek = url && url.indexOf("api.deepseek.com/chat/completions") !== -1;
      if (isDeepSeek && init && init.body) {
        var body = JSON.parse(init.body);
        var message = latestUser(body.messages);
        if (wantsBrochure(message)) {
          return Promise.resolve(new Response(JSON.stringify({
            id: "frere-local-brochure-reply",
            object: "chat.completion",
            model: "frere-local-brochure",
            choices: [{ index: 0, message: { role: "assistant", content: brochureReply(message) }, finish_reason: "stop" }],
            usage: null
          }), { status: 200, headers: { "content-type": "application/json" } }));
        }
        if (Array.isArray(body.messages) && body.messages[0] && body.messages[0].role === "system") {
          body.messages[0].content = String(body.messages[0].content || "") + "\\n\\n" + KNOWLEDGE;
          init = Object.assign({}, init, { body: JSON.stringify(body) });
        }
      }
    } catch (error) {
      // Keep normal chat behavior if the local patch cannot modify one request.
    }
    return originalFetch(input, init);
  };
})();



/* FRERE industrial application and technical-agreement knowledge patch. */
(function () {
  "use strict";

  if (window.__frereIndustrialApplicationKnowledgePatchV1) return;
  window.__frereIndustrialApplicationKnowledgePatchV1 = true;

  var INDUSTRIAL_KNOWLEDGE = [
    "FRERE INDUSTRIAL APPLICATION KNOWLEDGE V1:",
    "Source handling rule: The following knowledge was rebuilt from industry presentations and technical-agreement style materials. Treat legacy supplier/company names and legacy product series in source materials as replaced by FRERE. Do not mention legacy supplier names, third-party product series, or legacy model codes to customers unless the customer provides them for cross-reference. Use FRERE product names and ask FRERE technical staff to confirm exact model, drawing, price, delivery, certificates, and performance guarantee.",
    "FRERE product mapping rule: MBR applications use FRERE Apexis MBR. Submerged/open UF or SMF applications use FRERE Lumina submerged UF. Pressurized UF, pure-water UF, RO pretreatment and high-recovery UF applications use FRERE Prisma pressurized UF. Industrial brackish/reuse RO applications use FRERE Vesta BSW RO. High-salinity/high-recovery RO and ZLD concentration applications use FRERE Lattice high-pressure RO. Nanofiltration applications use FRERE Stratix NF. Oily, strong acid/alkali, high-organic or harsh wastewater membrane applications use FRERE Fluxion PTFE. Gas-liquid and liquid-liquid coalescing/separation uses FRERE FL coalescing cartridges and separators. Metal sintered felt, stainless steel, titanium and cleanable high-temperature cartridges use FRERE FM metallic cartridges. PP, PES, PTFE, nylon, glass fiber, activated carbon and melt-blown prefilters use FRERE FR non-metallic cartridge families.",
    "Do not overclaim source cases as public FRERE references. If a user asks whether a specific company or project is an official FRERE reference, answer that project disclosure and reference permission must be confirmed by FRERE sales. You may discuss the application conditions and selection logic generally.",
    "",
    "Municipal wastewater and reclaimed water: Municipal sewage usually has relatively low COD/BOD5, nitrogen/phosphorus fluctuation, variable flow and load, and increasingly high reclaimed-water requirements. Typical reuse routes include biological treatment plus FRERE Apexis MBR, FRERE Lumina submerged UF or FRERE Prisma UF, followed by FRERE Vesta RO where desalination is required. FRERE Apexis MBR is suitable for municipal effluent upgrade, reuse and compact wastewater plants because PVDF hollow fiber membrane, high porosity and uniform pore distribution improve flux and fouling resistance. A pulse-aeration MBR design can reduce air demand versus continuous perforated aeration and can support lower air-water ratio under suitable design. For reclaimed-water RO, use FRERE Vesta RO as the default; use FRERE Stratix NF when organic/COD or selective ion removal is the target; use FRERE Lattice high-pressure RO for concentrated brine or ZLD stages.",
    "Municipal water quality references from the materials: typical municipal sewage COD/BOD5 can be about 150-400/80-200 ppm and TN/TP about 25-50/3-8 ppm, but actual design must use local water analysis. When discussing municipal reuse, ask for influent COD, BOD5, SS, NH3-N, TN, TP, oil, surfactants, temperature, flow curve, reuse target and discharge standard.",
    "",
    "Coal chemical wastewater: Coal gasification, liquefaction, coking and downstream coal-chemical processes generate wastewater with complex organics, phenols, cyanide, ammonia nitrogen, refractory aromatic compounds, suspended coal/ash particles, possible waste oil/emulsified oil and high salinity. Treatment often needs biochemical treatment plus membrane polishing and reuse. Recommended FRERE train: pretreatment and biological system, FRERE Apexis MBR or FRERE Lumina/Prisma UF for solids/colloids/microbes, FRERE Vesta RO for reuse desalination, FRERE Stratix NF for COD/organics or divalent ion control, and FRERE Lattice high-pressure RO for high-salt concentration/ZLD. For oily coal-chemical water or harsh cleaning conditions, consider FRERE Fluxion PTFE for stronger chemical tolerance and antifouling.",
    "Coal chemical/coal wastewater design guidance: ask for phenols, cyanide, ammonia, COD, BOD/COD ratio, oil, SS, TDS, hardness, silica, chloride, sulfate, temperature, pH, oxidants, antiscalant plan, cleaning chemicals, target recovery, concentrate route and discharge/reuse target. Do not promise direct RO performance without pilot data or water analysis.",
    "",
    "Coal mine water: Mine water may contain fine suspended solids, coal dust, rock powder, clay, light particles with slow settling, oil/emulsified oil and dissolved salts. In large coal-producing regions, mine-water reuse volume can be very large. Typical FRERE train: coagulation/sedimentation or clarification, FRERE Lumina submerged UF or FRERE Prisma pressurized UF for turbidity/SS/colloid control, then FRERE Vesta RO for desalination/reuse where needed. For mixed domestic sewage plus mine water, FRERE Apexis MBR can be used before UF/RO depending on biodegradability and treatment target.",
    "Coal mine application reference ranges from the source materials: mixed mine/domestic wastewater projects may use MBR/SMF/UF plus RO combinations; example design flux references included MBR about 13-16 LMH for domestic sewage, UF about 40-50 LMH for mine water, and RO about 17-22 LMH for desalination water. Treat these as preliminary reference ranges only; confirm by pilot/water quality.",
    "",
    "Steel wastewater: Steel plants have many water streams: coking wastewater, sintering/balling wastewater, blast-furnace gas washing water, slag flushing water, converter dust-removal water, cold-rolling oily wastewater and hot-rolling turbid circulating water. Coking wastewater can be toxic and refractory, with COD often very high; cold-rolling wastewater can contain oil and emulsified oil. Typical FRERE process: biological treatment and FRERE Apexis MBR for coking/biochemical effluent, FRERE Lumina submerged UF or FRERE Prisma UF for desalination pretreatment, FRERE Vesta RO for reuse desalination, FRERE Stratix NF or FRERE Lattice high-pressure RO for high-salt/ZLD concentration, and FRERE Fluxion PTFE for oily, strong acid/alkali or difficult wastewater.",
    "Steel wastewater references from materials: coking wastewater COD may be around 3000-6000 mg/L; cold-rolling oily wastewater may contain oil about 50-500 mg/L. Ask the customer to separate streams and provide each stream's oil, COD, SS, hardness, alkalinity, silica, iron, temperature and cleaning constraints before selection.",
    "",
    "Semiconductor and electronic water: Applications include electronic-grade pure water, ultrapure water pretreatment, CMP/研磨 wastewater, LCD/OLED panel wastewater, electroplating or metal-containing wastewater and broad semiconductor industrial wastewater reuse. Typical FRERE product selection: FRERE Prisma pressurized UF for pure-water pretreatment and particle/colloid/microbe removal, FRERE Vesta RO for low-pressure desalination and reuse, FRERE Apexis MBR for biodegradable electronic wastewater, FRERE Lumina submerged UF for open-tank reuse/pretreatment, and FRERE Stratix NF or FRERE Lattice HP RO where selective removal or high-salt concentration is required.",
    "Semiconductor guidance: pay attention to nickel, chromium, hexavalent chromium, fluoride, ammonia, organic solvents, surfactants, silica, boron, particles, SDI, TOC, conductivity and final ultrapure-water train requirements. Source materials referenced strict discharge limits such as total nickel below 0.1 ppm, total chromium below 0.5 ppm and hexavalent chromium below 0.1 ppm for relevant regulated streams; confirm actual local standard.",
    "",
    "Power plant water: Key systems include boiler makeup demineralized water, circulating cooling blowdown treatment, wet FGD wastewater/ZLD, plant-wide wastewater reuse and reclaimed water. FRERE Prisma UF is suitable for boiler makeup and RO pretreatment to reduce SDI, turbidity, colloids, bacteria and particles. FRERE Vesta RO is suitable for boiler makeup desalination and circulating-water reuse. FRERE Lattice high-pressure RO is suitable for high-salt concentrate and ZLD concentration. FRERE Stratix NF can be used for hardness/COD/selective separation before RO or evaporation when appropriate.",
    "Power plant process references: typical routes include coagulation/clarification/filtration -> FRERE UF -> FRERE RO -> mixed bed or polishing for boiler makeup; circulating cooling blowdown can use UF plus RO, concentrate RO, high-pressure RO and NF depending on recovery target; wet FGD wastewater/ZLD can use pretreatment plus NF/RO/high-pressure RO before evaporation/crystallization. Example source cases referenced two-stage RO permeate conductivity below 2.5 uS/cm in one boiler-makeup application, but do not guarantee this without water analysis and design confirmation.",
    "",
    "Petrochemical coalescing and prefiltration: FRERE FL coalescing cartridges and separators are applicable for gas-liquid and liquid-liquid separation in C4, butane/butene, butadiene extraction, MTBE/butene-1, fuel gas, styrene/water and other hydrocarbon/water or gas droplet removal duties. FRERE prefilters protect coalescers by removing solids before liquid-liquid separation. Typical coalescer targets in the technical materials include outlet free water around 15 ppm for hydrocarbon liquid services and very low downstream mist for fuel-gas services, but exact guarantee depends on feed composition, interfacial tension, surfactants, emulsion stability, flow, temperature, pressure, density difference and separator design.",
    "Butadiene extraction/C4 hydrocarbon coalescer guidance: source technical materials included butane/butene and C4-related liquid service with inlet water around 1000 ppm(wt), outlet free water target around 15 ppm(wt), prefilter precision around 5 micron, polyester coalescing/filter elements, and restrictions such as no glass fiber in certain cartridges and no copper/PTFE wetted parts for certain butadiene/MTBE services. When quoting FRERE, map this to FRERE FL liquid-liquid coalescer plus FRERE FR prefilter or FRERE FM cleanable prefilter depending on solids, temperature and compatibility. Always verify material compatibility for C4, butadiene, MTBE, butene-1 and acetylene-containing service.",
    "MTBE/butene-1 coalescer guidance: source materials included C4 liquid streams and separator positions with design/normal flow ranges, inlet water about 1000 ppm(wt), outlet free water target about 15 ppm(wt), prefilter precision about 5 micron and coalescer service life target above 3 years under normal conditions. Treat these as design references, not blanket guarantees.",
    "Fuel gas coalescer guidance: gas-liquid coalescers protect downstream burners, compressors, turbines, amine contactors, gas separation membranes, mole sieves and catalysts by removing liquid aerosols and fine droplets. A source technical agreement referenced a fuel gas tank coalescer with glass microfiber media, 152 x 1016 mm elements, 48 cartridges, design liquid load around 2540 ppmw and downstream mist target about <=0.011 ppmw. For FRERE response, describe this as a high-efficiency FRERE FL gas-liquid coalescer application and ask for gas composition, pressure, temperature, flow, liquid load, droplet size, aerosol/oil/water type and required outlet mist.",
    "Styrene/water coalescer case from scanned agreement: service was styrene/water liquid-liquid coalescing. Reference process parameters: flow about 4.6 m3/h, oil/water density about 887/1000 kg/m3, operating temperature about 40 C, maximum operating pressure about 1.6 MPaG, viscosity about 0.571 cP, inlet dispersed water concentration <=10000 ppm, expected outlet oil-phase water content <=15 ppm, prefilter precision about 10 micron, coalescer cartridge quantity 5, minimum shell ID about 43 cm, DN50 nozzle, initial pressure drop about 5-10 kPa, coalescer element length about 165 cm, horizontal vessel and minimum liquid hold-up around 50 L. For FRERE, map to FRERE FL liquid-liquid coalescing separator plus correct prefilter.",
    "C4 hydrogenation prefilter guidance: one technical agreement for a coalescer prefilter included FRERE FM metallic sintered felt style cartridges and glass-fiber/depth cartridges. Useful reference points: metal sintered felt and glass-fiber cartridges can be designed for similar dimensions and replacement; metal sintered felt cartridges can be cleaned and reused, with suggested cleaning methods such as high-pressure water or ultrasonic cleaning; source reference collapse differential pressure was about 0.4 MPa at 40 C, replacement differential pressure about 0.2 MPa for metal sintered felt and about 0.1 MPa for glass-fiber cartridges. Confirm final values by FRERE datasheet and housing design.",
    "Petrochemical standards and QA themes: source technical agreements referenced pressure vessel and petrochemical filter standards such as TSG21, GB/T150, SH/T3411 and related welding, coating, packaging and material standards. Common requirements include 316L nameplate/grounding parts where specified, chloride limit for hydrotest water on stainless/overlay equipment, drawing/data approval, material certificates, pressure testing, NDE, packing, spare parts and as-built documentation. When customers ask for compliance, collect applicable codes and confirm with FRERE engineering.",
    "",
    "Activated carbon and living-water cartridge filters: A living-water retrofit technical agreement referenced activated carbon filter units after UF permeate to dechlorinate, adsorb organics, remove heavy metals/odor/color and residual turbidity, improving domestic water quality. FRERE mapping: use FRERE activated carbon plus PP composite cartridge/filter housing or FRERE FR non-metallic cartridge family. Reference design included 64 sets, SS304 housing, DN50 inlet/outlet, 5 micron activated carbon + PP element, vertical unit, single cartridge per set, shell design life target >=10 years and cartridge replacement cycle commonly 3-6 months depending on inlet water. Confirm exact flow and element size by datasheet.",
    "",
    "Reference application types from petrochemical materials: PPS, PO, alkylation, refining/aromatics, caprolactam, HPA separation, wastewater oil removal, C4/MTBE/butadiene streams, gas-liquid coalescing, liquid-liquid coalescing, automatic backwash filters, metallic cartridges, stainless sintered powder/felt cartridges, multi-stage filtration and ordinary guard cartridges. Use these as application prompts for solution discussion; do not disclose confidential project details or claim public references without approval.",
    "",
    "Customer question checklist for industrial wastewater/membranes: ask industry, water source, process section, flow average/peak, temperature, pH, COD/BOD, SS/turbidity/SDI, oil/emulsified oil, hardness/alkalinity, TDS/conductivity, chloride/sulfate/silica, heavy metals, oxidants, solvents/surfactants, target permeate quality, reuse/discharge standard, recovery target, cleaning chemicals, footprint, existing process, pain points, budget, delivery time and required certificates.",
    "Customer question checklist for coalescers/cartridges: ask gas/liquid or liquid/liquid service, fluid composition, density difference, viscosity, interfacial tension, inlet free/dispersed liquid content, droplet size if known, solids load and particle size, flow normal/maximum, pressure/temperature, allowed pressure drop, target outlet water/oil/mist, hazardous restrictions such as no copper/PTFE/glass fiber, housing size/interface, replacement interval and whether cleanable cartridges are preferred.",
    "Safety and claims rule: Never invent exact compatibility, cartridge life, outlet ppm, pressure drop, price, stock, lead time, certificate or drawing. Provide preliminary selection only and direct the customer to WhatsApp +86 13252994459 or support@frerechemical.com for engineering confirmation."
  ].join("\n");

  var originalFetch = window.fetch && window.fetch.bind(window);
  if (!originalFetch) return;

  window.fetch = function (input, init) {
    try {
      var url = typeof input === "string" ? input : input && input.url;
      var isDeepSeek = url && url.indexOf("api.deepseek.com/chat/completions") !== -1;
      if (isDeepSeek && init && init.body) {
        var body = JSON.parse(init.body);
        if (Array.isArray(body.messages)) {
          if (body.messages[0] && body.messages[0].role === "system") {
            if (String(body.messages[0].content || "").indexOf("FRERE INDUSTRIAL APPLICATION KNOWLEDGE V1") === -1) {
              body.messages[0].content = String(body.messages[0].content || "") + "\n\n" + INDUSTRIAL_KNOWLEDGE;
            }
          } else {
            body.messages.unshift({ role: "system", content: INDUSTRIAL_KNOWLEDGE });
          }
          init = Object.assign({}, init, { body: JSON.stringify(body) });
        }
      }
    } catch (error) {
      // Keep normal chat behavior if local knowledge injection fails.
    }
    return originalFetch(input, init);
  };
})();



/* FRERE V2 filter knowledge, calculation helper, tone tuning, and linkifier. */
(function () {
  "use strict";

  var EN_URL = "https://cdn.shopify.com/s/files/1/0706/7549/7038/files/FRERE-Filter_cartridges_and_membrane_products-ENGLISH.pdf?v=1781061423";
  var RU_URL = "https://cdn.shopify.com/s/files/1/0706/7549/7038/files/FRERE-Filter_Cartridges_and_Membrane_products-russia.pdf?v=1777354099";
  var CONTACT = "FRERE contact:\nWhatsApp: +86 13252994459\nEmail: support@frerechemical.com\nWebsite: https://www.frerechemical.com";

  var BASE = [
    "You are the FRERE website assistant for filtration, filter cartridges, filter housings, coalescers and membrane products.",
    "Answer in the customer's language: English, Chinese or Russian. Your assistant name is Celine. If the chat history contains no earlier assistant reply, briefly introduce yourself as Celine, FRERE's sales consultant, with one light friendly emoji. After that, do not repeat the introduction unless asked.",
    "Be professional, warm and human-like, like an attentive female technical sales consultant. A tiny friendly touch is fine; use at most one light emoji only when it feels natural, and avoid emojis in dense technical specs.",
    "Do not claim to be a human. Do sound conversational: if the question is vague, ask focused follow-up questions before giving a firm recommendation.",
    "Keep replies concise. Use short paragraphs or bullets. Do not give a huge textbook answer. Preserve technical details that affect selection.",
    "When information is missing, ask 3-6 useful questions at once: fluid or gas composition, flow, target micron/removal, temperature, pressure, viscosity, pH/chemicals, solids or droplet load, housing/interface, replacement or cleaning expectation, and certificate/code needs.",
    "If the customer cannot answer everything in one round, give a nearest preliminary FRERE solution or relevant case reference, then say which data still needs confirmation.",
    "Do not mention internal source brands, source document names or old source company names. Map source content to FRERE products only. Competitor names may be discussed only if the customer directly asks for a comparison.",
    "For cases, keep real known city/project details when they are available. Do not hide a real city as 'some city'. If the city is not known, say similar project/reference case.",
    "Never invent exact chemical compatibility, final model, price, stock, certificate, drawing, dimensions, delivery time, guaranteed life, pressure drop or guaranteed outlet ppm. Say FRERE engineering should confirm.",
    CONTACT,
    "FRERE product map: FR non-metallic cartridges including PP, PES, PTFE, nylon, glass fiber, polyester/PBT, PFA/PVDF/E-CTFE, activated carbon, melt-blown, string-wound and depth media; FM metallic cartridges including stainless steel sintered mesh, folded mesh, sintered fiber felt, powder sintered and titanium; FL coalescing cartridges/separators for liquid-liquid and gas-liquid service; filter housings and skids; Apexis MBR; Lumina submerged UF; Prisma pressurized UF; Vesta BSW RO; Lattice high-pressure RO; Stratix NF; Fluxion PTFE membrane; FRERE membrane contactors."
  ].join("\n");

  var BROCHURE = [
    "FRERE brochure links:",
    "English brochure: " + EN_URL,
    "Russian brochure: " + RU_URL,
    "",
    CONTACT
  ].join("\n");

  var FILTER_MATERIALS = [
    "FRERE FR non-metallic cartridge selection: PP pleated cartridges are the broad first choice for cost-effective liquid prefiltration, general acids/alkalis, many solvents and RO guard filtration. PP variants can be selected for low extractables, high precision, high dirt-holding or high-flow service. Typical initial precision range is about 0.1-100 micron depending on construction; final range must follow FRERE datasheet.",
    "For higher dirt load, colloids, gelatin, paint, ink, adhesive, resin, slurry-like process fluids or long service life, consider FRERE FR depth/gradient PP, high dirt-holding pleated media, melt-blown PP, string-wound/depth cartridges or glass fiber media. Give a preliminary direction, then ask for solids loading, viscosity, flow and allowed differential pressure.",
    "For fine liquid filtration and hydrophilic service, consider FRERE FR PES, nylon 66 or fine PP/glass fiber depending on chemistry. Nylon can be useful for compatible solvents and fine particle/bio-burden style filtration; PES is common for water-based fine filtration. Confirm oxidants, solvents and pH before selection.",
    "For strong acids, alkalis, oxidants, ozone, aggressive solvents, gas venting or electronics chemicals, consider FRERE FR PTFE, hydrophilic PTFE, PFA/PVDF/E-CTFE style fluoropolymer options, or Fluxion PTFE membrane when it is a membrane system. Ask exact chemical name, concentration, temperature and whether the duty is liquid, gas or vent.",
    "For aromatic solvents and higher temperature organic service, polyester/PBT or nylon may be considered only after compatibility confirmation. For adsorption, dechlorination, odor/color and organic trace removal, use FRERE activated carbon cartridges or activated-carbon-plus-PP composite cartridges."
  ].join("\n");

  var FILTER_HOUSINGS = [
    "FRERE can discuss cartridges plus housings/skids: single-cartridge housings, multi-cartridge housings, sanitary housings, liquid pipeline filters, high-flow housings, bag housings, gas filters, corrosion-resistant housings, FRP/PP/fluoropolymer-lined options, lab filters and skid systems.",
    "Housing selection questions: flow normal/max, cartridge size and quantity, inlet/outlet nozzle standard, design pressure/temperature, material such as SS304/SS316L/FRP/PP/lined steel, gasket material, vertical/horizontal layout, quick-open or bolted closure, drain/vent, code requirement, cleaning method and spare cartridge plan.",
    "For high-flow cartridges, use them for RO guard, seawater/reuse pretreatment, condensate, cooling water and large process liquid flows when fewer elements and lower maintenance are desired. FRERE high-flow preliminary selection should confirm length, micron rating, flow per element, inlet SS/turbidity, viscosity and allowed pressure drop."
  ].join("\n");

  var METAL = [
    "FRERE FM metallic cartridges cover stainless steel folded mesh, sintered mesh, five-layer sintered mesh, stainless sintered fiber felt, stainless powder sintered and titanium powder sintered styles. They suit high temperature, high pressure, cleanable/reusable, backwashable and harsh chemical or petrochemical duties.",
    "Use stainless mesh/folded mesh where low pressure drop, high strength and cleanability matter; sintered fiber felt where depth loading and high dirt-holding are useful; powder sintered where rigid porous structure and uniform pores are needed; titanium for compatible corrosive service. Typical precision can range from sub-micron/few-micron to 100+ micron depending on type; do not state final precision without FRERE datasheet.",
    "Ask metal-cartridge customers for fluid, solids size/load, target micron, operating and design pressure/temperature, viscosity, corrosion risk, cleaning/backwash method, collapse pressure, housing size and whether the element must be welded, threaded, DOE/SOE or customized."
  ].join("\n");

  var COALESCER = [
    "FRERE FL coalescing selection: liquid-liquid coalescers separate dispersed water from hydrocarbons or oil from water by prefiltration, droplet coalescence and phase separation. Gas-liquid coalescers remove mist/aerosol and liquids from gas streams to protect compressors, burners, turbines, amine/glycol units, membranes, molecular sieves, catalysts and instruments.",
    "For liquid-liquid service, ask continuous phase, dispersed phase, density difference, viscosity, interfacial tension, surfactants/emulsifiers, solids load, inlet water/oil ppm, target outlet ppm, flow, pressure, temperature, available vessel orientation and residence time. Low interfacial tension and surfactants make separation harder.",
    "For gas-liquid service, ask gas composition, normal/max gas flow, pressure, temperature, liquid/aerosol load, droplet size if known, target outlet mist, solids, compressor oil or water carryover, hazardous restrictions and allowed differential pressure. Give a preliminary FRERE FL direction, not a guarantee."
  ].join("\n");

  var MEMBRANE_CONTACTOR = [
    "FRERE membrane contactors use hydrophobic hollow-fiber membrane interface for gas-liquid mass transfer, such as dissolved oxygen removal, CO2 control, degassing or gas dosing. Useful fields include ultrapure water, semiconductor/LCD rinsing water, boiler feedwater, polymerization water, inkjet fluids and other gas-sensitive liquids.",
    "Ask membrane-contactor customers for liquid flow, inlet and target dissolved oxygen/CO2, vacuum or sweep gas availability, liquid temperature, pressure, pH, conductivity, surfactants/oil risk, particulate pretreatment, allowed pressure drop and installation mode. Hydrophobic membrane wetting risk must be checked if surfactants or solvents are present."
  ].join("\n");

  var CALC = [
    "Calculation helper rules. If the customer gives enough data, calculate directly in 2-4 lines, then list the assumptions. If data is missing, ask for it instead of pretending.",
    "Membrane flux J = permeate flow / active membrane area. With Q in m3/h and flux J in LMH: required area A(m2) = Q x 1000 / J. With Q in m3/day: A = Q x 1000 / 24 / J. Example: 100 m3/h at 50 LMH needs about 2000 m2.",
    "For RO/NF area, use permeate/product flow. If the customer gives feed flow and recovery R, calculate permeate flow Qp = Qf x R and concentrate Qc = Qf - Qp. Concentration factor CF = 1 / (1 - R), where R is decimal. Example: 100 m3/h feed at 75% recovery gives 75 m3/h permeate and CF 4.",
    "Element count: N = ceiling(required membrane area / active area per element). If active area is unknown, ask for the FRERE element model. A rough 8-inch RO element area may be around 37-41 m2, but model-specific data controls.",
    "Cartridge count: N = ceiling(total flow / safe flow per cartridge). Safe flow depends on cartridge size, micron, viscosity, solids load, clean pressure drop and terminal pressure drop. If safe flow is not known, ask for the cartridge type or propose FRERE engineering confirmation.",
    "Useful unit conversion: 1 m3/h = 1000 L/h. 1 GFD is about 1.697 LMH; LMH = GFD x 1.697."
  ].join("\n");

  var MEMBRANE = [
    "FRERE membrane mapping: MBR uses FRERE Apexis MBR; submerged/open UF uses FRERE Lumina submerged UF; pressurized UF/pure-water UF/RO pretreatment uses FRERE Prisma UF; industrial reuse RO uses FRERE Vesta BSW RO; high-salinity/ZLD concentration uses FRERE Lattice high-pressure RO; NF uses FRERE Stratix NF; oily or harsh wastewater membrane service uses FRERE Fluxion PTFE.",
    "Apexis MBR: 0.05 micron PVDF hollow fiber, high porosity, antifouling design, stronger backwash resistance and pulse aeration support. Lumina/Prisma UF: 0.03 micron PVDF UF for turbidity, particles, colloids and bacteria reduction before reuse or RO.",
    "Typical preliminary design flux references from FRERE training material: MBR domestic sewage about 13-16 LMH, UF mine water about 40-50 LMH, RO industrial reuse about 17-22 LMH. These are starting points only; water analysis, pilot data and cleaning strategy decide final design."
  ].join("\n");

  var MUNICIPAL = [
    "Municipal wastewater/reclaimed water: use biological treatment plus FRERE Apexis MBR, Lumina submerged UF or Prisma UF, followed by Vesta RO where desalination is needed. Ask COD, BOD5, SS, NH3-N, TN, TP, oil, surfactants, temperature, average/peak flow, reuse target and discharge standard.",
    "Typical municipal sewage reference only: COD/BOD5 may be about 150-400/80-200 ppm and TN/TP about 25-50/3-8 ppm. Use actual water analysis for design."
  ].join("\n");

  var COAL = [
    "Coal chemical wastewater: often contains phenols, cyanide, ammonia nitrogen, refractory aromatics, coal/ash particles, oil or emulsified oil and high salinity. Typical FRERE train: pretreatment/biological system, Apexis MBR or Lumina/Prisma UF, Vesta RO for reuse desalination, Stratix NF for COD/organics or divalent-ion control, and Lattice HP RO for high-salt/ZLD concentration. Fluxion PTFE can be considered for oily or harsh cleaning conditions.",
    "Coal mine water: often contains fine suspended solids, coal dust, rock powder, clay, slow-settling particles, oil/emulsified oil and salts. Typical FRERE train: clarification, Lumina or Prisma UF for turbidity/SS/colloids, then Vesta RO if desalination/reuse is required."
  ].join("\n");

  var STEEL = [
    "Steel wastewater: streams include coking wastewater, sintering, blast-furnace gas washing, slag flushing, converter dust-removal, cold-rolling oily wastewater and hot-rolling turbid circulating water. Coking wastewater can be toxic/refractory; cold rolling may contain emulsified oil. Typical FRERE process: Apexis MBR for coking/biochemical effluent, Lumina/Prisma UF for RO pretreatment, Vesta RO for reuse desalination, Stratix NF or Lattice HP RO for high-salt/ZLD stages, and Fluxion PTFE for oily or strong chemical wastewater.",
    "Reference values only: coking wastewater COD may be about 3000-6000 mg/L; cold-rolling oily wastewater may contain oil about 50-500 mg/L. Ask each stream's oil, COD, SS, hardness, alkalinity, silica, iron, temperature and cleaning constraints."
  ].join("\n");

  var SEMI = [
    "Semiconductor/electronic water: applications include electronic-grade pure water pretreatment, ultrapure water pretreatment, CMP wastewater, LCD/OLED panel wastewater, electroplating/metal-containing wastewater and reuse. Use Prisma UF for particles/colloids before RO, Vesta RO for desalination/reuse, Apexis MBR for biodegradable electronic wastewater, Lumina UF for open-tank reuse/pretreatment, and Stratix NF or Lattice HP RO for selective removal/high-salt concentration.",
    "Ask for nickel, chromium, hexavalent chromium, fluoride, ammonia, solvents, surfactants, silica, boron, particles, SDI, TOC, conductivity and final UPW or discharge target."
  ].join("\n");

  var POWER = [
    "Power plant water: systems include boiler makeup demineralized water, circulating cooling blowdown, wet FGD wastewater/ZLD and plant-wide reuse. Use Prisma UF for RO pretreatment, Vesta RO for boiler makeup desalination and reuse, Lattice HP RO for high-salt concentrate/ZLD, and Stratix NF for hardness/COD/selective separation before RO or evaporation.",
    "Typical boiler makeup route: coagulation/clarification/filtration -> FRERE UF -> FRERE RO -> mixed bed/polishing. Wet FGD/ZLD may need NF/RO/HP RO before evaporation/crystallization. Do not guarantee permeate conductivity without water analysis and design."
  ].join("\n");

  var PETRO = [
    "Petrochemical coalescing/prefiltration: FRERE FL is used for gas-liquid and liquid-liquid separation in C4, butane/butene, butadiene extraction, MTBE/butene-1, fuel gas, styrene/water and hydrocarbon-water services. Prefilters protect coalescers by removing solids before separation.",
    "C4/butadiene/MTBE references: source materials included inlet water around 1000 ppm(wt), outlet free water target around 15 ppm(wt), prefilter precision around 5 micron, polyester elements, and restrictions such as no glass fiber or no copper/PTFE wetted parts in certain services. Always verify material compatibility for C4, butadiene, MTBE, butene-1 and acetylene-containing services.",
    "Styrene/water case reference: flow about 4.6 m3/h, 40 C, max 1.6 MPaG, viscosity about 0.571 cP, inlet dispersed water <=10000 ppm, outlet oil-phase water <=15 ppm, prefilter about 10 micron, horizontal vessel. Map to FRERE FL liquid-liquid coalescer plus correct prefilter.",
    "C4 hydrogenation prefilter: FRERE FM metallic sintered felt can be considered when cleanable/reusable elements are needed; high-pressure water or ultrasonic cleaning may be options. Confirm collapse differential pressure and replacement differential pressure by FRERE datasheet."
  ].join("\n");

  var CARBON = [
    "Activated carbon/domestic water cartridge filter: after UF permeate, activated carbon plus PP composite cartridge can dechlorinate, adsorb organics, remove odor/color/residual turbidity and improve domestic water quality. FRERE mapping: FR activated carbon + PP composite cartridge/filter housing. A reference design used SS304 housing, DN50 inlet/outlet, 5 micron element, vertical unit and 3-6 month cartridge replacement cycle depending on water quality."
  ].join("\n");

  var ROUTES = [
    { key: "calc", re: /(calculate|calculation|sizing|membrane area|flux|recovery|how many elements|how many cartridges|\u8ba1\u7b97|\u9009\u578b|\u819c\u9762\u79ef|\u901a\u91cf|\u56de\u6536\u7387|\u591a\u5c11\u652f|\u591a\u5c11\u6839|\u0440\u0430\u0441\u0447\u0435\u0442|\u043f\u043b\u043e\u0449\u0430\u0434\u044c)/i, text: CALC },
    { key: "brochure", re: /(brochure|catalogue|catalog|pdf|download|document|leaflet|manual|datasheet|product book|\u5ba3\u4f20\u518c|\u4ea7\u54c1\u518c|\u76ee\u5f55|\u6837\u672c|\u8d44\u6599|\u4e0b\u8f7d|\u043a\u0430\u0442\u0430\u043b\u043e\u0433|\u0431\u0440\u043e\u0448\u044e\u0440|\u0441\u043a\u0430\u0447\u0430\u0442\u044c|\u0434\u043e\u043a\u0443\u043c\u0435\u043d\u0442)/i, text: BROCHURE },
    { key: "contactor", re: /(membrane contactor|degas|degassing|deoxygen|oxygen removal|co2 removal|carbon dioxide|\u819c\u63a5\u89e6\u5668|\u8131\u6c14|\u9664\u6c27|\u6eb6\u89e3\u6c27|\u4e8c\u6c27\u5316\u78b3|\u0434\u0435\u0433\u0430\u0437)/i, text: MEMBRANE_CONTACTOR },
    { key: "metal", re: /(metal cartridge|sintered|stainless|titanium|mesh|powder|fiber felt|\u91d1\u5c5e\u6ee4\u82af|\u70e7\u7ed3|\u4e0d\u9508\u94a2|\u949b|\u7f16\u7ec7\u7f51|\u6298\u53e0\u7f51|\u7c89\u672b|\u043c\u0435\u0442\u0430\u043b)/i, text: METAL },
    { key: "coalescer", re: /(coalesc|separator|mist|oil water|gas liquid|liquid liquid|hydrocarbon water|\u805a\u7ed3|\u5206\u79bb|\u9664\u96fe|\u6cb9\u6c34|\u6c14\u6db2|\u6db2\u6db2|\u70c3\u6c34|\u043a\u043e\u0430\u043b\u0435\u0441|\u0441\u0435\u043f\u0430\u0440)/i, text: COALESCER },
    { key: "housing", re: /(housing|vessel|skid|bag filter|high flow|pipeline filter|filter system|\u58f3\u4f53|\u8fc7\u6ee4\u5668|\u6ed1\u67b6|\u888b\u5f0f|\u5927\u6d41\u91cf|\u7ba1\u9053\u8fc7\u6ee4|\u0444\u0438\u043b\u044c\u0442\u0440-\u043a\u043e\u0440\u043f\u0443\u0441)/i, text: FILTER_HOUSINGS },
    { key: "coal", re: /(coal chemical|coal mine|mine water|\u7164\u5316\u5de5|\u7164\u77ff|\u77ff\u4e95|\u7126\u5316)/i, text: COAL },
    { key: "steel", re: /(steel|coking wastewater|cold rolling|\u94a2\u94c1|\u7126\u5316\u5e9f\u6c34|\u51b7\u8f67)/i, text: STEEL },
    { key: "semi", re: /(semiconductor|electronic|cmp|ultrapure|lcd|oled|\u534a\u5bfc\u4f53|\u7535\u5b50|\u8d85\u7eaf\u6c34|\u7814\u78e8|\u6676\u5706|\u9762\u677f)/i, text: SEMI },
    { key: "power", re: /(power plant|boiler|cooling blowdown|fgd|desulfurization|\u7535\u5382|\u9505\u7089|\u5faa\u73af\u6c34|\u8131\u786b|\u96f6\u6392\u653e)/i, text: POWER },
    { key: "municipal", re: /(municipal|reclaimed water|sewage|wastewater reuse|\u5e02\u653f|\u6c61\u6c34|\u518d\u751f\u6c34|\u4e2d\u6c34\u56de\u7528)/i, text: MUNICIPAL },
    { key: "petro", re: /(petrochemical|butadiene|mtbe|butene|styrene|fuel gas|c4|propylene|aromatic|\u77f3\u5316|\u4e01\u4e8c\u70ef|\u4e01\u70ef|\u82ef\u4e59\u70ef|\u71c3\u6599\u6c14|\u78b3\u56db|\u4e19\u70ef|\u82b3\u70c3)/i, text: PETRO },
    { key: "carbon", re: /(activated carbon|domestic water|drinking water|life water|dechlorination|\u6d3b\u6027\u70ad|\u751f\u6d3b\u7528\u6c34|\u996e\u7528\u6c34|\u8131\u6c2f)/i, text: CARBON },
    { key: "membrane", re: /(mbr|uf|ro|nf|ptfe membrane|membrane|ultrafiltration|reverse osmosis|nanofiltration|\u819c|\u8d85\u6ee4|\u53cd\u6e17\u900f|\u7eb3\u6ee4|\u805a\u56db\u6c1f\u4e59\u70ef)/i, text: MEMBRANE },
    { key: "filter", re: /(cartridge|filter|micron|material|pp|pes|ptfe|nylon|glass fiber|polyester|pbt|pfa|pvdf|melt blown|string wound|depth|\u6ee4\u82af|\u7cbe\u5ea6|\u6750\u8d28|\u73bb\u7ea4|\u805a\u4e19\u70ef|\u5c3c\u9f99|\u7194\u55b7|\u7ebf\u7ed5|\u6df1\u5c42|\u805a\u916f|\u0444\u0438\u043b\u044c\u0442\u0440)/i, text: FILTER_MATERIALS }
  ];

  function hasChinese(text) {
    return /[\u4e00-\u9fff]/.test(text);
  }

  function hasRussian(text) {
    return /[\u0400-\u04ff]/.test(text);
  }

  function brochureReply(message) {
    if (hasChinese(message)) {
      return withCelineIntro(message, [
        "可以的 😊 FRERE 宣传册在这里：",
        "",
        "English brochure: " + EN_URL,
        "Russian brochure: " + RU_URL,
        "",
        "联系方式：",
        "WhatsApp: +86 13252994459",
        "Email: support@frerechemical.com",
        "Website: https://www.frerechemical.com"
      ].join("\n"));
    }
    if (hasRussian(message)) {
      return withCelineIntro(message, [
        "Конечно 😊 Брошюры FRERE:",
        "",
        "English brochure: " + EN_URL,
        "Russian brochure: " + RU_URL,
        "",
        "Contact FRERE:",
        "WhatsApp: +86 13252994459",
        "Email: support@frerechemical.com",
        "Website: https://www.frerechemical.com"
      ].join("\n"));
    }
    return withCelineIntro(message, [
      "Sure 😊 Here are the FRERE brochures:",
      "",
      "English brochure: " + EN_URL,
      "Russian brochure: " + RU_URL,
      "",
      CONTACT
    ].join("\n"));
  }

  function shouldIntroduce() {
    try {
      if (window.localStorage && window.localStorage.getItem("frereCelineIntroducedV1") === "1") return false;
      if (window.localStorage) window.localStorage.setItem("frereCelineIntroducedV1", "1");
    } catch (error) {
      if (window.__frereCelineIntroducedV1) return false;
      window.__frereCelineIntroducedV1 = true;
    }
    return true;
  }

  function withCelineIntro(message, reply) {
    if (!shouldIntroduce()) return reply;
    if (hasChinese(message)) return "你好，我是 Celine，FRERE 的销售顾问 😊\n" + reply;
    if (hasRussian(message)) return "Здравствуйте, я Celine, sales consultant FRERE 😊\n" + reply;
    return "Hi, I'm Celine, FRERE's sales consultant 😊\n" + reply;
  }

  function numberFrom(match, index) {
    if (!match || match[index] == null) return null;
    var value = Number(String(match[index]).replace(",", "."));
    return Number.isFinite(value) ? value : null;
  }

  function parseFlow(text) {
    var m = text.match(/(\d+(?:[.,]\d+)?)\s*(?:m3\/h|m\^3\/h|m³\/h|m3h|m³h|cbm\/h|t\/h|tph|tons?\/h|\u65b9\/\u5c0f\u65f6|\u65b9\u6bcf\u5c0f\u65f6|\u5428\/\u5c0f\u65f6|\u7acb\u65b9\u7c73\/\u5c0f\u65f6)/i);
    if (m) return { value: numberFrom(m, 1), unit: "m3/h", m3h: numberFrom(m, 1) };

    m = text.match(/(\d+(?:[.,]\d+)?)\s*(?:m3\/d|m\^3\/d|m³\/d|m3\/day|m³\/day|cmd|tons?\/day|\u65b9\/\u5929|\u5428\/\u5929|\u7acb\u65b9\u7c73\/\u5929)/i);
    if (m) return { value: numberFrom(m, 1), unit: "m3/day", m3h: numberFrom(m, 1) / 24 };

    m = text.match(/(\d+(?:[.,]\d+)?)\s*(?:l\/h|L\/h|liter\/h|liters\/h|\u5347\/\u5c0f\u65f6)/);
    if (m) return { value: numberFrom(m, 1), unit: "L/h", m3h: numberFrom(m, 1) / 1000 };

    m = text.match(/(\d+(?:[.,]\d+)?)\s*(?:gpm|GPM)/);
    if (m) return { value: numberFrom(m, 1), unit: "gpm", m3h: numberFrom(m, 1) * 0.2271247 };

    return null;
  }

  function parseFlux(text) {
    var m = text.match(/(\d+(?:[.,]\d+)?)\s*(?:lmh|LMH|l\/m2\/h|L\/m2\/h|l\/m²\/h|L\/m²\/h|\u5347\/\u5e73\u65b9\u7c73\/\u5c0f\u65f6|\u5347\/\u5e73\u7c73\/\u5c0f\u65f6)/i);
    if (m) return { value: numberFrom(m, 1), unit: "LMH", lmh: numberFrom(m, 1) };

    m = text.match(/(\d+(?:[.,]\d+)?)\s*(?:gfd|GFD)/);
    if (m) return { value: numberFrom(m, 1), unit: "GFD", lmh: numberFrom(m, 1) * 1.697 };

    return null;
  }

  function parseRecovery(text) {
    var m = text.match(/(?:recovery|recovery rate|\u56de\u6536\u7387)\D{0,12}(\d+(?:[.,]\d+)?)\s*%/i) || text.match(/(\d+(?:[.,]\d+)?)\s*%\D{0,12}(?:recovery|recovery rate|\u56de\u6536\u7387)/i);
    if (!m) return null;
    var value = numberFrom(m, 1);
    return value && value > 0 && value < 100 ? value / 100 : null;
  }

  function roundNice(value) {
    if (!Number.isFinite(value)) return "";
    if (value >= 100) return String(Math.round(value));
    if (value >= 10) return String(Math.round(value * 10) / 10);
    return String(Math.round(value * 100) / 100);
  }

  function hasPriorAssistant(messages) {
    if (!Array.isArray(messages)) return false;
    for (var i = 0; i < messages.length; i += 1) {
      if (messages[i] && messages[i].role === "assistant") return true;
    }
    return false;
  }

  function calculationReply(message) {
    var wantsArea = /(membrane area|\u819c\u9762\u79ef|\u591a\u5c11\u5e73|\u591a\u5c11\u33a1|\u591a\u5c11m2|area|calculate|calculation|\u8ba1\u7b97|\u7b97)/i.test(message);
    if (!wantsArea) return null;

    var flow = parseFlow(message);
    var flux = parseFlux(message);
      if (!flow || !flux) {
        if (hasChinese(message)) {
        return withCelineIntro(message, "可以算的 😊 还差一点关键数据：请发我处理量/产水量、设计通量 LMH、膜类型（MBR/UF/RO/NF），如果是 RO 再加目标回收率。这样我就能先给你粗算膜面积。");
      }
      if (hasRussian(message)) {
        return withCelineIntro(message, "Могу посчитать 😊 Пришлите расход, расчетный flux в LMH, тип мембраны (MBR/UF/RO/NF), а для RO еще recovery. Тогда я быстро дам предварительную площадь мембран.");
      }
      return withCelineIntro(message, "Sure 😊 Please send the flow, design flux in LMH, membrane type (MBR/UF/RO/NF), and RO recovery if it is an RO system. Then I can calculate a preliminary membrane area.");
    }

    var recovery = parseRecovery(message);
    var isFeedFlow = /(feed|influent|\u8fdb\u6c34|\u539f\u6c34)/i.test(message);
    var isRo = /\bRO\b|reverse osmosis|\u53cd\u6e17\u900f/i.test(message);
    var qForArea = flow.m3h;
    var recoveryLine = "";
    var recoveryLineCn = "";
    if (isRo && recovery && isFeedFlow) {
      qForArea = flow.m3h * recovery;
      recoveryLine = "RO permeate flow Qp = feed flow x recovery = " + roundNice(flow.m3h) + " x " + roundNice(recovery * 100) + "% = " + roundNice(qForArea) + " m3/h.";
      recoveryLineCn = "RO 产水量 Qp = 进水量 x 回收率 = " + roundNice(flow.m3h) + " x " + roundNice(recovery * 100) + "% = " + roundNice(qForArea) + " m3/h。";
    }

    var area = qForArea * 1000 / flux.lmh;
    if (hasChinese(message)) {
      return withCelineIntro(message, [
        "可以的 😊 先按你给的数据粗算：",
        recoveryLineCn || "我先按这个流量就是产水/处理流量来算。",
        "膜面积 A = Q x 1000 / J = " + roundNice(qForArea) + " x 1000 / " + roundNice(flux.lmh) + " = 约 " + roundNice(area) + " m²。",
        "",
        "这是初步面积，不是最终型号。还需要确认膜类型、水质、温度、污染风险、反洗/清洗策略和 FRERE 单支膜面积。"
      ].filter(Boolean).join("\n"));
    }
    if (hasRussian(message)) {
      return withCelineIntro(message, [
        "Конечно 😊 Предварительный расчет:",
        recoveryLine || "I treat the given flow as permeate/process flow for this quick estimate.",
        "Area A = Q x 1000 / J = " + roundNice(qForArea) + " x 1000 / " + roundNice(flux.lmh) + " = about " + roundNice(area) + " m².",
        "",
        "This is preliminary sizing. Final FRERE model needs membrane type, water quality, temperature, fouling risk, cleaning strategy and element area."
      ].filter(Boolean).join("\n"));
    }
    return withCelineIntro(message, [
      "Sure 😊 Quick preliminary calculation:",
      recoveryLine || "I treat the given flow as permeate/process flow for this quick estimate.",
      "Area A = Q x 1000 / J = " + roundNice(qForArea) + " x 1000 / " + roundNice(flux.lmh) + " = about " + roundNice(area) + " m².",
      "",
      "This is preliminary sizing. Final FRERE model needs membrane type, water quality, temperature, fouling risk, cleaning strategy and element area."
    ].filter(Boolean).join("\n"));
  }

  function latestUser(messages) {
    if (!Array.isArray(messages)) return "";
    for (var i = messages.length - 1; i >= 0; i -= 1) {
      if (messages[i] && messages[i].role === "user") return String(messages[i].content || "");
    }
    return "";
  }

  function selectedKnowledge(message) {
    var text = String(message || "");
    var parts = [BASE];
    var matched = {};
    for (var i = 0; i < ROUTES.length; i += 1) {
      var route = ROUTES[i];
      if (route.key !== "brochure" && route.re.test(text) && !matched[route.key]) {
        matched[route.key] = true;
        parts.push(route.text);
      }
      if (parts.length >= 5) break;
    }
    if (!matched.filter && !matched.housing && !matched.metal && !matched.coalescer && !matched.membrane && !matched.contactor) {
      parts.push(FILTER_MATERIALS);
    }
    if (/(water|wastewater|\u6c34|\u5e9f\u6c34|\u56de\u7528|\u6c61\u6c34)/i.test(text) && !matched.membrane && parts.length < 5) {
      parts.push(MEMBRANE);
    }
    return parts.join("\n\n");
  }

  function trimMessages(messages) {
    if (!Array.isArray(messages)) return [];
    var system = messages[0] && messages[0].role === "system" ? messages[0] : null;
    var rest = system ? messages.slice(1) : messages.slice();
    var trimmedRest = rest.slice(-5);
    return system ? [system].concat(trimmedRest) : trimmedRest;
  }

  function jsonResponse(content, model) {
    return Promise.resolve(new Response(JSON.stringify({
      id: "frere-local-v2",
      object: "chat.completion",
      model: model || "frere-local-v2",
      choices: [{ index: 0, message: { role: "assistant", content: content }, finish_reason: "stop" }],
      usage: null
    }), { status: 200, headers: { "content-type": "application/json" } }));
  }

  function getNativeFetch(fallbackFetch) {
    try {
      var iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.setAttribute("aria-hidden", "true");
      document.documentElement.appendChild(iframe);
      return iframe.contentWindow.fetch.bind(iframe.contentWindow);
    } catch (error) {
      return fallbackFetch;
    }
  }

  function installRouter() {
    if (!window.fetch) return;
    var fallbackFetch = window.fetch.bind(window);
    var cleanFetch = getNativeFetch(fallbackFetch);
    window.__frereOptimizedPromptRouterV2 = true;
    window.__frereOptimizedPromptRouterV2AppliedAt = Date.now();

    window.fetch = function (input, init) {
      try {
        var url = typeof input === "string" ? input : input && input.url;
        var isDeepSeek = url && url.indexOf("api.deepseek.com/chat/completions") !== -1;
        if (!isDeepSeek || !init || !init.body) return fallbackFetch(input, init);

        var body = JSON.parse(init.body);
        var userMessage = latestUser(body.messages);

        if (ROUTES[1].re.test(userMessage)) {
          return jsonResponse(brochureReply(userMessage), "frere-local-brochure-v2");
        }

        var calc = calculationReply(userMessage);
        if (calc) return jsonResponse(calc, "frere-local-calc-v2");

        if (!hasPriorAssistant(body.messages)) shouldIntroduce();
        body.messages = trimMessages(body.messages);
        var prompt = selectedKnowledge(userMessage);
        if (body.messages[0] && body.messages[0].role === "system") {
          body.messages[0].content = prompt;
        } else {
          body.messages.unshift({ role: "system", content: prompt });
        }
        body.temperature = 0.25;
        body.max_tokens = Math.min(Number(body.max_tokens) || 520, 520);
        body.stream = false;
        init = Object.assign({}, init, { body: JSON.stringify(body) });
        return cleanFetch(input, init);
      } catch (error) {
        return fallbackFetch(input, init);
      }
    };
  }

  function linkifyElement(element) {
    if (!element || element.nodeType !== 1 || element.dataset.frereLinkified === "1") return;
    var tag = element.tagName && element.tagName.toLowerCase();
    if (/^(script|style|textarea|input|button|a)$/.test(tag)) return;
    if (element.children.length > 0) return;
    var text = element.textContent || "";
    if (text.indexOf("https://") === -1 && text.indexOf("support@frerechemical.com") === -1) return;
    var urlRegex = /(https:\/\/[^\s]+)/g;
    if (!urlRegex.test(text)) return;
    urlRegex.lastIndex = 0;

    var fragment = document.createDocumentFragment();
    var lastIndex = 0;
    var match;
    while ((match = urlRegex.exec(text))) {
      var url = match[1].replace(/[).,，。]+$/, "");
      var trailing = match[1].slice(url.length);
      fragment.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
      var a = document.createElement("a");
      a.href = url;
      a.target = "_blank";
      a.rel = "noopener noreferrer";
      a.textContent = url.indexOf("russia.pdf") !== -1 ? "Russian brochure" : (url.indexOf("ENGLISH.pdf") !== -1 ? "English brochure" : url);
      a.style.color = "#0f766e";
      a.style.textDecoration = "underline";
      a.style.wordBreak = "break-word";
      fragment.appendChild(a);
      if (trailing) fragment.appendChild(document.createTextNode(trailing));
      lastIndex = match.index + match[1].length;
    }
    fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
    element.textContent = "";
    element.appendChild(fragment);
    element.dataset.frereLinkified = "1";
  }

  function collectRoots() {
    var roots = [document];
    try {
      Array.prototype.forEach.call(document.querySelectorAll("*"), function (element) {
        if (element.shadowRoot) roots.push(element.shadowRoot);
      });
    } catch (error) {}
    return roots;
  }

  function scanLinks() {
    collectRoots().forEach(function (root) {
      try {
        Array.prototype.forEach.call(root.querySelectorAll("div,p,span,li"), linkifyElement);
      } catch (error) {}
    });
  }

  function installLinkifier() {
    scanLinks();
    if (window.__frereLinkifierV2) return;
    window.__frereLinkifierV2 = true;
    try {
      var observer = new MutationObserver(function () { scanLinks(); });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    } catch (error) {}
    var runs = 0;
    var timer = setInterval(function () {
      scanLinks();
      runs += 1;
      if (runs > 20) clearInterval(timer);
    }, 700);
  }

  installRouter();
  installLinkifier();
  setTimeout(installRouter, 500);
  setTimeout(installRouter, 1500);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      installRouter();
      installLinkifier();
    }, { once: true });
  }
  window.addEventListener("load", function () {
    setTimeout(installRouter, 300);
    setTimeout(installRouter, 1800);
    installLinkifier();
  }, { once: true });
})();



/* FRERE optimized prompt router patch. Keeps responses faster by sending only topic-relevant knowledge. */
(function () {
  "use strict";

  if (window.__frereOptimizedPromptRouterV1) return;
  window.__frereOptimizedPromptRouterV1 = true;

  var EN_URL = "https://cdn.shopify.com/s/files/1/0706/7549/7038/files/FRERE-Filter_cartridges_and_membrane_products-ENGLISH.pdf?v=1781061423";
  var RU_URL = "https://cdn.shopify.com/s/files/1/0706/7549/7038/files/FRERE-Filter_Cartridges_and_Membrane_products-russia.pdf?v=1777354099";
  var CONTACT = "FRERE contact: WhatsApp +86 13252994459; email support@frerechemical.com; website https://www.frerechemical.com.";

  var BASE = [
    "You are the official FRERE website assistant for filtration, filter cartridges and membrane products.",
    "Answer in the customer's language. Supported languages include English, Chinese and Russian.",
    "Be concise, practical and sales-support oriented. Ask 1-3 key selection questions when data is missing.",
    "Never invent exact chemical compatibility, price, stock, certificate, drawing, dimensions, delivery time, lifetime or guaranteed performance. Say FRERE technical staff must confirm.",
    CONTACT,
    "Core FRERE products: FR non-metallic cartridges including PP, PES, PTFE, nylon, glass fiber, activated carbon and melt-blown/depth media; FM metallic cartridges including stainless steel sintered mesh/felt and titanium; FL coalescing cartridges/separators for gas-liquid and liquid-liquid separation; Apexis MBR; Lumina submerged UF; Prisma pressurized UF; Vesta BSW RO; Lattice high-pressure RO; Stratix NF; Fluxion PTFE membrane; membrane contactors.",
    "General cartridge selection: ask fluid/gas composition, solids or droplet load, micron rating, flow, temperature, pressure, allowable differential pressure, viscosity, pH, oxidants, solvents, acids/alkalis, housing/interface, cartridge size and replacement/cleaning expectations."
  ].join("\n");

  var BROCHURE = [
    "FRERE brochure links:",
    "English brochure: " + EN_URL,
    "Russian brochure: " + RU_URL,
    CONTACT
  ].join("\n");

  var PRODUCT = [
    "FRERE cartridge summary: FR non-metallic cartridges cover economical prefiltration, fine filtration, corrosive chemicals, solvents and high purity liquids. PP is common for broad chemical service; PES is hydrophilic and useful for fine liquid filtration; PTFE is suitable for strong acids, alkalis, solvents and gas/vent duties depending on hydrophobic/hydrophilic grade; glass fiber and melt-blown/depth cartridges provide dirt-holding guard filtration.",
    "FRERE FM metallic cartridges are used for high temperature, high pressure, cleanable, regenerable and harsh services. Options include stainless steel sintered mesh/fiber felt and titanium. Use for hot liquids, steam, oil/gas, petrochemical, power and chemical processes when cleanability and strength matter.",
    "FRERE FL coalescing cartridges merge fine droplets into larger droplets for oil-water, hydrocarbon-water, gas-liquid and mist removal applications. They protect pumps, compressors, heat exchangers, meters, regulators, amine/glycol units, burners, membranes, mole sieves and catalysts."
  ].join("\n");

  var MEMBRANE = [
    "FRERE membrane mapping: MBR uses FRERE Apexis MBR; submerged/open UF uses FRERE Lumina submerged UF; pressurized UF/pure-water UF/RO pretreatment uses FRERE Prisma UF; industrial reuse RO uses FRERE Vesta BSW RO; high-salinity/ZLD concentration uses FRERE Lattice high-pressure RO; NF uses FRERE Stratix NF; oily or harsh wastewater membrane service uses FRERE Fluxion PTFE.",
    "Apexis MBR: 0.05 micron PVDF hollow fiber, high porosity, antifouling design, stronger backwash resistance, pulse aeration support and lower energy potential under suitable design.",
    "Lumina/Prisma UF: 0.03 micron PVDF UF for turbidity, particles, colloids, bacteria and virus reduction before reuse or RO. Prisma pressurized UF is suitable for RO pretreatment and high-recovery operation.",
    "Vesta RO targets stable desalination and reuse; Lattice HP RO targets high salinity/high recovery; Stratix NF targets organics/COD/selective ion control; Fluxion PTFE targets oily, strong acid/alkali, oxidant or difficult wastewater service."
  ].join("\n");

  var MUNICIPAL = [
    "Municipal wastewater/reclaimed water: use biological treatment plus FRERE Apexis MBR, Lumina submerged UF or Prisma UF, followed by Vesta RO where desalination is required. Ask for COD, BOD5, SS, NH3-N, TN, TP, oil, surfactants, temperature, average/peak flow, reuse target and discharge standard.",
    "Typical municipal sewage reference only: COD/BOD5 may be about 150-400/80-200 ppm and TN/TP about 25-50/3-8 ppm. Use actual local water analysis for design."
  ].join("\n");

  var COAL = [
    "Coal chemical wastewater: often contains phenols, cyanide, ammonia nitrogen, refractory aromatics, coal/ash particles, oil or emulsified oil and high salinity. Typical FRERE train: pretreatment/biological system, Apexis MBR or Lumina/Prisma UF, Vesta RO for reuse desalination, Stratix NF for COD/organics or divalent-ion control, and Lattice HP RO for high-salt/ZLD concentration. Fluxion PTFE can be considered for oily or harsh cleaning conditions.",
    "Coal mine water: often contains fine suspended solids, coal dust, rock powder, clay, slow-settling particles, oil/emulsified oil and salts. Typical FRERE train: clarification, Lumina or Prisma UF for turbidity/SS/colloids, then Vesta RO if desalination/reuse is required. Reference design flux ranges from source material: MBR about 13-16 LMH for domestic sewage, UF about 40-50 LMH for mine water, RO about 17-22 LMH; confirm by pilot/water analysis."
  ].join("\n");

  var STEEL = [
    "Steel wastewater: streams include coking wastewater, sintering, blast-furnace gas washing, slag flushing, converter dust-removal, cold-rolling oily wastewater and hot-rolling turbid circulating water. Coking wastewater can be toxic/refractory; cold rolling may contain emulsified oil. Typical FRERE process: Apexis MBR for coking/biochemical effluent, Lumina/Prisma UF for RO pretreatment, Vesta RO for reuse desalination, Stratix NF or Lattice HP RO for high-salt/ZLD stages, and Fluxion PTFE for oily or strong chemical wastewater.",
    "Reference values only: coking wastewater COD may be about 3000-6000 mg/L; cold-rolling oily wastewater may contain oil about 50-500 mg/L. Ask for each separated stream's oil, COD, SS, hardness, alkalinity, silica, iron, temperature and cleaning constraints."
  ].join("\n");

  var SEMI = [
    "Semiconductor/electronic water: applications include electronic-grade pure water pretreatment, ultrapure water pretreatment, CMP wastewater, LCD/OLED panel wastewater, electroplating/metal-containing wastewater and reuse. Use Prisma UF for particle/colloid/microbe removal before RO, Vesta RO for low-pressure desalination/reuse, Apexis MBR for biodegradable electronic wastewater, Lumina UF for open-tank reuse/pretreatment, and Stratix NF or Lattice HP RO for selective removal/high-salt concentration.",
    "Ask for nickel, chromium, hexavalent chromium, fluoride, ammonia, solvents, surfactants, silica, boron, particles, SDI, TOC, conductivity and final UPW or discharge target. Source materials referenced strict limits such as total nickel below 0.1 ppm, total chromium below 0.5 ppm and Cr(VI) below 0.1 ppm for relevant streams; confirm actual local standard."
  ].join("\n");

  var POWER = [
    "Power plant water: key systems include boiler makeup demineralized water, circulating cooling blowdown, wet FGD wastewater/ZLD and plant-wide reuse. Use Prisma UF for RO pretreatment, Vesta RO for boiler makeup desalination and reuse, Lattice HP RO for high-salt concentrate/ZLD, and Stratix NF for hardness/COD/selective separation before RO or evaporation.",
    "Typical boiler makeup route: coagulation/clarification/filtration -> FRERE UF -> FRERE RO -> mixed bed/polishing. Wet FGD/ZLD may need NF/RO/HP RO before evaporation/crystallization. Do not guarantee permeate conductivity without water analysis and design."
  ].join("\n");

  var PETRO = [
    "Petrochemical coalescing/prefiltration: FRERE FL is used for gas-liquid and liquid-liquid separation in C4, butane/butene, butadiene extraction, MTBE/butene-1, fuel gas, styrene/water and hydrocarbon-water services. Prefilters protect coalescers by removing solids before separation.",
    "C4/butadiene/MTBE references: source materials included inlet water about 1000 ppm(wt), outlet free water target around 15 ppm(wt), prefilter precision around 5 micron, polyester elements, and restrictions such as no glass fiber or no copper/PTFE wetted parts in certain services. Always verify material compatibility for C4, butadiene, MTBE, butene-1 and acetylene-containing services.",
    "Fuel gas coalescer reference: high-efficiency gas-liquid coalescer may protect burners, compressors, turbines, amine contactors, gas separation membranes, mole sieves and catalysts. Ask gas composition, pressure, temperature, flow, liquid load, droplet size, aerosol/oil/water type and required outlet mist.",
    "Styrene/water case reference: flow about 4.6 m3/h, 40 C, max 1.6 MPaG, viscosity about 0.571 cP, inlet dispersed water <=10000 ppm, outlet oil-phase water <=15 ppm, prefilter about 10 micron, horizontal vessel. Map to FRERE FL liquid-liquid coalescer plus correct prefilter.",
    "C4 hydrogenation prefilter: FRERE FM metallic sintered felt can be considered when cleanable/reusable elements are needed; high-pressure water or ultrasonic cleaning may be options. Confirm collapse differential pressure and replacement differential pressure by FRERE datasheet."
  ].join("\n");

  var CARBON = [
    "Activated carbon/domestic water cartridge filter: after UF permeate, activated carbon plus PP composite cartridge can dechlorinate, adsorb organics, remove odor/color/residual turbidity and improve domestic water quality. FRERE mapping: FR activated carbon + PP composite cartridge/filter housing. Reference design included SS304 housing, DN50 inlet/outlet, 5 micron element, vertical unit and 3-6 month cartridge replacement cycle depending on water quality."
  ].join("\n");

  var ROUTES = [
    { key: "brochure", re: /(brochure|catalogue|catalog|pdf|download|document|leaflet|manual|datasheet|product book|\u5ba3\u4f20\u518c|\u4ea7\u54c1\u518c|\u76ee\u5f55|\u6837\u672c|\u8d44\u6599|\u4e0b\u8f7d|\u043a\u0430\u0442\u0430\u043b\u043e\u0433|\u0431\u0440\u043e\u0448\u044e\u0440|\u0441\u043a\u0430\u0447\u0430\u0442\u044c|\u0434\u043e\u043a\u0443\u043c\u0435\u043d\u0442)/i, text: BROCHURE },
    { key: "coal", re: /(coal chemical|coal mine|mine water|\u7164\u5316\u5de5|\u7164\u77ff|\u77ff\u4e95|\u7126\u5316)/i, text: COAL },
    { key: "steel", re: /(steel|coking wastewater|cold rolling|\u94a2\u94c1|\u7126\u5316\u5e9f\u6c34|\u51b7\u8f67)/i, text: STEEL },
    { key: "semi", re: /(semiconductor|electronic|cmp|ultrapure|lcd|oled|\u534a\u5bfc\u4f53|\u7535\u5b50|\u8d85\u7eaf\u6c34|\u7814\u78e8|\u6676\u5706|\u9762\u677f)/i, text: SEMI },
    { key: "power", re: /(power plant|boiler|cooling blowdown|fgd|desulfurization|\u7535\u5382|\u9505\u7089|\u5faa\u73af\u6c34|\u8131\u786b|\u96f6\u6392\u653e)/i, text: POWER },
    { key: "municipal", re: /(municipal|reclaimed water|sewage|wastewater reuse|\u5e02\u653f|\u6c61\u6c34|\u518d\u751f\u6c34|\u4e2d\u6c34\u56de\u7528)/i, text: MUNICIPAL },
    { key: "petro", re: /(coalesc|separator|petrochemical|butadiene|mtbe|butene|styrene|fuel gas|c4|oil water|gas liquid|\u805a\u7ed3|\u77f3\u5316|\u4e01\u4e8c\u70ef|\u4e01\u70ef|\u82ef\u4e59\u70ef|\u71c3\u6599\u6c14|\u6cb9\u6c34|\u6c14\u6db2|\u6db2\u6db2|\u78b3\u56db)/i, text: PETRO },
    { key: "carbon", re: /(activated carbon|domestic water|drinking water|life water|\u6d3b\u6027\u70ad|\u751f\u6d3b\u7528\u6c34|\u996e\u7528\u6c34)/i, text: CARBON },
    { key: "membrane", re: /(mbr|uf|ro|nf|ptfe|membrane|ultrafiltration|reverse osmosis|nanofiltration|\u819c|\u8d85\u6ee4|\u53cd\u6e17\u900f|\u7eb3\u6ee4|\u805a\u56db\u6c1f\u4e59\u70ef)/i, text: MEMBRANE },
    { key: "product", re: /(cartridge|filter|micron|material|pp|pes|ptfe|nylon|metal|titanium|stainless|\u6ee4\u82af|\u8fc7\u6ee4\u5668|\u7cbe\u5ea6|\u6750\u8d28|\u91d1\u5c5e|\u949b|\u4e0d\u9508\u94a2)/i, text: PRODUCT }
  ];

  var previousFetch = window.fetch && window.fetch.bind(window);
  if (!previousFetch) return;

  function nativeFetch() {
    try {
      var iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.setAttribute("aria-hidden", "true");
      document.documentElement.appendChild(iframe);
      var f = iframe.contentWindow.fetch.bind(iframe.contentWindow);
      return f;
    } catch (error) {
      return previousFetch;
    }
  }

  var cleanFetch = nativeFetch();

  function latestUser(messages) {
    if (!Array.isArray(messages)) return "";
    for (var i = messages.length - 1; i >= 0; i -= 1) {
      if (messages[i] && messages[i].role === "user") return String(messages[i].content || "");
    }
    return "";
  }

  function localReply(message) {
    if (/[\u4e00-\u9fff]/.test(message)) {
      return "\u53ef\u4ee5\uff0cFRERE \u5ba3\u4f20\u518c\u4e0b\u8f7d\u94fe\u63a5\u5982\u4e0b\uff1a\n\u82f1\u6587\u5ba3\u4f20\u518c\uff1a" + EN_URL + "\n\u4fc4\u6587\u5ba3\u4f20\u518c\uff1a" + RU_URL + "\n\n\u8054\u7cfb\u65b9\u5f0f\uff1aWhatsApp +86 13252994459\uff0c\u90ae\u7bb1 support@frerechemical.com\uff0c\u7f51\u7ad9 https://www.frerechemical.com\u3002";
    }
    if (/[\u0400-\u04ff]/.test(message)) {
      return "\u0412\u044b \u043c\u043e\u0436\u0435\u0442\u0435 \u0441\u043a\u0430\u0447\u0430\u0442\u044c \u0431\u0440\u043e\u0448\u044e\u0440\u044b FRERE \u0437\u0434\u0435\u0441\u044c:\nEnglish: " + EN_URL + "\nRussian: " + RU_URL + "\n\nWhatsApp +86 13252994459, email support@frerechemical.com, website https://www.frerechemical.com.";
    }
    return BROCHURE;
  }

  function selectedKnowledge(message) {
    var text = String(message || "");
    var parts = [BASE];
    var matched = {};
    for (var i = 0; i < ROUTES.length; i += 1) {
      var route = ROUTES[i];
      if (route.key !== "brochure" && route.re.test(text) && !matched[route.key]) {
        matched[route.key] = true;
        parts.push(route.text);
      }
    }
    if (parts.length === 1) parts.push(PRODUCT);
    if (parts.length < 4 && /(water|wastewater|\u6c34|\u5e9f\u6c34|\u56de\u7528)/i.test(text) && !matched.membrane) {
      parts.push(MEMBRANE);
    }
    return parts.join("\n\n");
  }

  function trimMessages(messages) {
    if (!Array.isArray(messages)) return [];
    var system = messages[0] && messages[0].role === "system" ? messages[0] : null;
    var rest = system ? messages.slice(1) : messages.slice();
    var trimmedRest = rest.slice(-6);
    return system ? [system].concat(trimmedRest) : trimmedRest;
  }

  window.fetch = function (input, init) {
    try {
      var url = typeof input === "string" ? input : input && input.url;
      var isDeepSeek = url && url.indexOf("api.deepseek.com/chat/completions") !== -1;
      if (!isDeepSeek || !init || !init.body) return previousFetch(input, init);

      var body = JSON.parse(init.body);
      var userMessage = latestUser(body.messages);
      if (ROUTES[0].re.test(userMessage)) {
        return Promise.resolve(new Response(JSON.stringify({
          id: "frere-local-brochure-reply",
          object: "chat.completion",
          model: "frere-local-brochure",
          choices: [{ index: 0, message: { role: "assistant", content: localReply(userMessage) }, finish_reason: "stop" }],
          usage: null
        }), { status: 200, headers: { "content-type": "application/json" } }));
      }

      body.messages = trimMessages(body.messages);
      var prompt = selectedKnowledge(userMessage);
      if (body.messages[0] && body.messages[0].role === "system") {
        body.messages[0].content = prompt;
      } else {
        body.messages.unshift({ role: "system", content: prompt });
      }
      body.temperature = 0.2;
      body.max_tokens = Math.min(Number(body.max_tokens) || 550, 550);
      body.stream = false;
      init = Object.assign({}, init, { body: JSON.stringify(body) });
      return cleanFetch(input, init);
    } catch (error) {
      return previousFetch(input, init);
    }
  };
})();

